<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header d-flex">
      <bread-crumb></bread-crumb>
      <b-alert
        v-model="showAlertTop"
        variant="danger"
        class="ml-5 transaction-alert"
        dismissible
      >
        <h4 class="alert-heading">Error!</h4>
        <p class="mb-0">
          Whenever you need to, be sure to use margin utilities to keep things
          nice and tidy.
        </p>
      </b-alert>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Middleware Transaction List</h2>
          </div>
          <!-- Transaction Listing-->
          <div class="body pt-0">
            <!-- Filters/Buttons -->
            <div
              class="chart-top-action d-lg-flex justify-content-end py-lg-0 py-3"
            >
              <!-- <div class="p-2 mr-auto">
                                <VMdDateRangePicker class="pull-right" opens='left' v-model="dateRange" @change="getSelectedDateRange($event)" :presets="presets" :autoApply="false"></VMdDateRangePicker>
                            </div> -->
              <!-- SearchBox Filters -->
              <!-- <div class="d-flex align-items-center flex-column flex-md-row-reverse justify-content-center justify-content-md-start mb-3 payment-dropdown"> -->
              <!-- <b-dropdown v-if="false" class="mr-0 mw-" id="download" text="Download" size="lg" variant="outline-primary btn-mw">
                                    <template #button-content>
                                        Download <i class="fa fa-download"></i>
                                    </template>
                                    <b-dropdown-item href="">Export as PDF</b-dropdown-item>
                                    <b-dropdown-item href="">Export as Excel</b-dropdown-item>
                                    <b-dropdown-item href="">Export as CSV</b-dropdown-item>
                                </b-dropdown> -->
              <div class="mr-0 mr-lg-3 action-top-search py-lg-3 py-0">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchText"
                    placeholder="Enter Keywords"
                    aria-label="Enter Keywords"
                    aria-describedby="search-transactions"
                    v-on:keyup.enter="getTransactionList"
                  />
                  <div
                    class="input-group-append"
                    @click="searchText ? getTransactionList() : '-'"
                  >
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Toggle Filter Button -->
              <!-- <div class="fliter-main mr-auto mt-3 mt-lg-0">
                                    <b-button class="fliter-btn btn-lg btn-mw"
                                        :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                                        @click="isVisibleFilter = !isVisibleFilter">Filter <i class="fa fa-filter"
                                            aria-hidden="true"></i></b-button>
                                </div> -->
              <div class="fliter-main mr-auto mt-3 mt-lg-0 py-lg-3 py-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <!-- </div> -->
              <div
                class="filter-select d-flex flex-md-row flex-column mt-3 mt-lg-0 py-lg-3 py-0"
              >
                <div
                  class="d-flex flex-sm-row flex-column"
                  v-if="
                    this.transactions.filter((data) => data.selected === true)
                      .length > 0
                  "
                >
                  <div class="country-dropdown curancy-dropdown mb-0">
                    <div
                      class="form-group form-select single-multiselect mb-0 mr-sm-2"
                    >
                      <span class="float-label">
                        <label for="bulkcapture">Bulk Payout</label>
                        <multiselect
                          placeholder="Select option"
                          v-model="bulkCapturestatus"
                          :show-labels="false"
                          :options="bulkCaptureOption"
                          :searchable="false"
                          @input="showalertForbulkcapture"
                        ></multiselect>
                      </span>
                    </div>
                  </div>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.bulk'])">
                    <b-button
                      class="fliter-btn btn-lg btn-mw mr-2 mt-1 mt-sm-0"
                      variant="primary"
                    >
                      Bulk Capture
                    </b-button>
                  </template>
                </div>
                <!-- <div class="country-dropdown curancy-dropdown mb-0 mt-md-0 mt-3">
                                    <div class="form-group form-select single-multiselect mb-0">
                                        <span class="float-label">
                                        <label for="roles">Select Tradename</label>
                                        <multiselect
                                            placeholder="Select Tradename"
                                            v-model="tradename" 
                                            :show-labels="false" 
                                            :options="tradename_options" 
                                            :searchable="false"
                                            label="name"
                                            @select="setprovider">
                                        </multiselect>  
                                        </span>
                                    </div>
                                </div> -->
              </div>
              <!-- Toggle Filter Collapse -->
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id == 'firstname' ||
                          item.field.id == 'lastname' ||
                          item.field.id == 'receiverfirstname' ||
                          item.field.id == 'receiverlastname' ||
                          item.field.id == 'receivermiddlename' ||
                          //item.field.id == 'email' ||
                          //item.field.id == 'senderphone' ||
                          //item.field.id == 'receiverphone' ||
                          item.field.id == 'middlename' ||
                          item.field.id == 'payment_res_id' ||
                          item.field.id == 'payout_res_id' ||
                          item.field.id == 'transaction_ref' ||
                          item.field.id == 'ip_address' ||
                          item.field.id == 'bank_name')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                      <div class="line"></div>
                    </div>

                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'mobile_network'"
                    >
                      <span class="float-label w-100">
                        <label>Select Mobile Money Network</label>
                        <v-select
                          v-model="item.mobile_network"
                          :options="momoProviderList"
                          multiple
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>

                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'remitterstatus'"
                    >
                      <span class="float-label w-100">
                        <label>Select Remiter Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="remiterOption"
                          label="name"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>

                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'payout_source'"
                    >
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                      >
                        <span class="float-label w-100">
                          <label>Select Payout type</label>
                          <multiselect
                            placeholder=""
                            v-model="item.payout.type"
                            :show-labels="false"
                            :options="filterpayouttype"
                            label="name"
                            track-by="value"
                            :searchable="true"
                            @select="selectPayout"
                          ></multiselect>
                        </span>
                      </div>
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                        v-if="item.payout.type"
                      >
                        <span class="float-label w-100">
                          <label>Select Payout Source</label>
                          <multiselect
                            placeholder=""
                            v-model="item.payout.source"
                            :show-labels="false"
                            :options="payoutSourceOption"
                            label="name"
                            track-by="value"
                            :searchable="true"
                            @search-change="searchPayoutSource"
                          ></multiselect>
                        </span>
                      </div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'country'"
                    >
                      <span class="float-label w-100">
                        <label>Select Dest. Country</label>
                        <v-select
                          v-model="item.country"
                          :options="countryList"
                          multiple
                          :get-option-label="(option) => option.name"
                          @input="getCountryWiseMomoProvider(item.country)"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'sourcecountry'"
                    >
                      <span class="float-label w-100">
                        <label>Select Source Country</label>
                        <v-select
                          v-model="item.country"
                          :options="countryList"
                          multiple
                          :get-option-label="(option) => option.name"
                        >
                          <template #option="option">
                            <div class="option__desc">
                              <span
                                :class="
                                  'flag-icon flag-icon-' +
                                  option.isoCode.toLowerCase() +
                                  ' fi-md fi-round '
                                "
                              ></span>
                              <span class="option__title">
                                {{ option.name }}
                              </span>
                            </div>
                          </template>
                        </v-select>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'transaction_status'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">
                          Select Transaction Status
                        </label>
                        <multiselect
                          placeholder=""
                          v-model="item.transactionStatus"
                          :show-labels="false"
                          :options="transactionStatus"
                          multiple
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'transactiontype'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">Select Transaction Type</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="transactiontypeOptions"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'cko_capture'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">CKO Capture Status</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="[
                            { value: 'captured', name: 'Captured' },
                            { value: 'not_captured', name: 'To be Captured' },
                          ]"
                          label="name"
                          track-by="value"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'amount'"
                    >
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                      >
                        <span class="float-label">
                          <label for="transaction">Select</label>
                          <multiselect
                            placeholder=""
                            v-model="item.amount.type"
                            :show-labels="false"
                            :options="amountOptions"
                            :searchable="true"
                            label="name"
                            track-by="id"
                            @select="amountFieldUpdate"
                          ></multiselect>
                        </span>
                        <div class="line"></div>
                      </div>
                      <div class="form-group m-0 column-2-half">
                        <input
                          class="form-control"
                          type="text"
                          v-model="item.amount.value"
                          :placeholder="'Enter ' + item.field.name"
                          @keypress="onlyNumber($event)"
                        />
                        <div class="line"></div>
                      </div>
                    </div>
                    <div
                      class="column-2"
                      v-if="
                        item.field && item.field.id == 'transaction_history'
                      "
                    >
                      <div class="form-group m-0 column-2-half">
                        <span class="float-label">
                          <input
                            class="form-control"
                            type="text"
                            id="sender"
                            v-model="item.history.sender"
                            placeholder="Enter sender PA ID"
                          />
                          <label for="sender" class="control-label">
                            Enter sender PA ID
                          </label>
                          <div class="line"></div>
                        </span>
                      </div>
                      <!-- <div class="form-group m-0 column-2-half">
                        <span class="float-label">
                          <input
                            class="form-control"
                            type="text"
                            id="receiver"
                            v-model="item.history.receiver"
                            placeholder="Enter receiver PA ref"
                          />
                          <label for="receiver" class="control-label"
                            >Enter receiver PA ref</label
                          >
                          <div class="line"></div>
                        </span>
                      </div> -->
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'date'"
                    >
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">From</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.from"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">To</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.to"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel & Close
                  </button>
                </div>
              </b-collapse>
            </div>
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Only for country filter-->
                <template
                  v-if="
                    item.filter_field == 'country' ||
                    item.filter_field == 'sourcecountry'
                  "
                >
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="country in item.filter_value"
                    :key="country"
                  >
                    {{
                      countryList.filter(
                        (data) => data.countryid === country,
                      )[0]?.countryname
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeCountry(country, item.filter_field, index)"
                    ></i>
                  </span>
                </template>
                <!-- Only for transaction status filter-->
                <template v-if="item.filter_field == 'transaction_status'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="status in item.filter_value"
                    :key="status"
                  >
                    {{ transactionStatus.filter((data) => data === status)[0] }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="removeStatus(status, item.filter_field, index)"
                    ></i>
                  </span>
                </template>
                <!-- Only for Date -->
                <template v-else-if="item.filter_field == 'date'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date">
                      {{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removeDate(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Only for Date -->
                <!--<template v-else-if="item.filter_field == 'payout_source'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date"
                      >{{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removePayoutSource(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>-->
                <!-- Only for transaction_history -->
                <template
                  v-else-if="item.filter_field == 'transaction_history'"
                >
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(item, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="item">
                      {{ indexValue + ": " + item }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removetransaction_history(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Only for mobile_network filter-->
                <template v-if="item.filter_field == 'mobile_network'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="networkId in item.filter_value"
                    :key="networkId"
                  >
                    {{
                      (item._mobile_network_objs
                        ? item._mobile_network_objs.find(
                            (opt) => (opt.id || opt.value || opt) === networkId,
                          )?.name
                        : networkId) || networkId
                    }}
                    <i
                      class="fa fa-close cursor-pointer ml-1"
                      @click="
                        removeNetwork(networkId, item.filter_field, index)
                      "
                    ></i>
                  </span>
                </template>
                <!-- Other filter -->
                <span
                  class="badge badge-warning-solid"
                  v-else-if="
                    typeof item.filter_value === 'string' ||
                    typeof item.filter_value === 'number'
                  "
                >
                  {{ item.filter_value }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- All Transaction List -->
            <b-table
              responsive
              ref="transactionTable"
              table-class="mb-0 table-custom border transaction-list-table"
              head-variant="light"
              :items="
                typeof transactions === 'array' ||
                typeof transactions === 'object'
                  ? transactions
                  : []
              "
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="onSortChanged"
              :emptyText="'No data found.'"
              show-empty
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #head(selected)>
                <div class="fancy-checkbox mr-0">
                  <label class="mb-0">
                    <input
                      type="checkbox"
                      v-model="selectAll"
                      @click="bulkSelectall"
                    />
                    <span></span>
                  </label>
                </div>
              </template>
              <template #cell(selected)="data">
                <div class="fancy-checkbox mr-0 mt-2">
                  <label>
                    <input type="checkbox" v-model="data.item.selected" />
                    <span></span>
                  </label>
                </div>
              </template>
              <template #cell(srccountry)="data">
                <div class="d-flex align-items-center">
                  <span :class="data.value.flagClass"></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.item.country?.countryname"
                  >
                    {{ data.item.country?.isocode.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(sender)="data">
                <div>
                  <img
                    v-if="data.item.customerGroup == 'Basic'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-basic.svg`)"
                  />
                  <img
                    v-else-if="
                      data.item.customerGroup == 'GREY - Unvalidated Profiles'
                    "
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-grey.svg`)"
                  />
                  <img
                    v-else-if="data.item.customerGroup == 'Silver'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-silver.svg`)"
                  />
                  <img
                    v-else-if="data.item.customerGroup == 'Silver+'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="
                      require(`@/assets/account-type-svg/plan-silver-plus.svg`)
                    "
                  />
                  <img
                    v-else-if="data.item.customerGroup == 'Bronze'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-bronze.svg`)"
                  />
                  <img
                    v-else-if="data.item.customerGroup == 'Red'"
                    width="20px"
                    v-b-tooltip.hover
                    :title="data.item.customerGroup"
                    :src="require(`@/assets/account-type-svg/plan-red.svg`)"
                  />
                  <a
                    class="font-color font-weight-bold"
                    href="javascript:void(0);"
                    @click="customerDetailModel(data.item.customer_id)"
                    :id="`tooltip${data.index}`"
                  >
                    <!-- :class="{'text-warning': (data.index == 1)}" -->
                    {{ data.value.name.substring(0, 19) }}
                    <span v-if="data.value.name.length > 19">...</span>
                  </a>
                  <b-tooltip
                    :target="`tooltip${data.index}`"
                    placement="right"
                    custom-class="customer-tooltip"
                  >
                    <h6 class="p-2 border-bottom text-left">
                      Customer Details
                    </h6>
                    <div class="tooltip-body p-2 text-left">
                      <div class="d-flex">
                        <div class="pb-2 label">Country:</div>
                        <div class="pb-2 value">
                          {{
                            data.item.country?.countryname
                              ? data.item.country.countryname
                              : "-"
                          }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">No of Cards:</div>
                        <div class="pb-2 value">{{ data.item.senderCard }}</div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">DTV:</div>
                        <!-- <div class="pb-2 value font-weight-bold text-warning" v-if="data.index == 1"> 3750</div> -->
                        <div class="pb-2 value">{{ data.item.senderDTV }}</div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">MTV:</div>
                        <div class="pb-2 value">{{ data.item.senderMTV }}</div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">LTV:</div>
                        <div class="pb-2 value">{{ data.item.senderLTV }}</div>
                      </div>
                      <div class="d-flex">
                        <div class="pb-2 label">No of Receivers:</div>
                        <div class="pb-2 value">
                          {{ data.item.noOfReceiver }}
                        </div>
                      </div>
                    </div>
                  </b-tooltip>
                </div>
              </template>
              <template #cell(benificiary)="data">
                <a
                  class="font-color font-weight-bold"
                  href="javascript:void(0);"
                  @click="customerDetailModel(data.item.receiver_id)"
                >
                  {{ data.value.name.substring(0, 19) }}
                  <span v-if="data.value.name.length > 19">...</span>
                </a>
              </template>
              <template #cell(custRefno)="data">
                <div>
                  <span class="mw-15 d-inline-block">
                    <i
                      :class="data.item.platform"
                      aria-hidden="true"
                      v-if="data.item.platform"
                    ></i>
                  </span>
                  <a
                    class="font-color"
                    href="javascript:void(0);"
                    @click="transactionDetails(data.item)"
                  >
                    {{ data.value }}
                  </a>
                  <i
                    class="fa fa-copy"
                    v-if="data.value != '-'"
                    @click="copyText(data.value, 'PA Ref')"
                  ></i>
                </div>
                <div class="d-block">
                  <span class="mw-15 d-inline-block">
                    <i
                      class="fa fa-times text-danger"
                      v-if="data.item.isCaptured == 0"
                    ></i>
                    <i class="fa fa-check text-success" v-else></i>
                  </span>
                  <span class="mw-15 d-inline-block">
                    <i
                      :class="data.item.platform"
                      aria-hidden="true"
                      v-if="data.item.platform"
                    ></i>
                  </span>
                  <span
                    :class="[
                      data.item.paymentProvider.class,
                      data.item.paymentMethodId ===
                      'fb491477-9b4a-410a-a008-a528ed1c0d27'
                        ? 'text-blue'
                        : data.item.paymentMethodId ===
                              'fb491477-9b4a-410a-a008-a528ed1c0d24' ||
                            data.item.paymentMethodId ===
                              'fb491477-9b4a-410a-a008-a528ed1c0d25'
                          ? 'text-warning'
                          : '',
                    ]"
                  >
                    {{ data.item.payment_res_id }}
                  </span>
                  <i
                    class="fa fa-copy"
                    v-if="data.item.payment_res_id != '-'"
                    @click="copyText(data.item.payment_res_id, 'Payment Ref')"
                  ></i>
                </div>
                <!-- <div class="text-grey d-block">
                  <span class="mw-15 d-inline-block"></span
                  >{{ data.item.payout_res_id }}
                  <i
                    class="fa fa-copy"
                    v-if="data.item.payout_res_id != '-'"
                    @click="copyText(data.item.payout_res_id, 'Payout Ref')"
                  ></i>
                </div> -->
              </template>
              <template #cell(datetime)="data">
                <strong>{{ data.value | YYYYMMDD }}</strong>
                <small class="text-grey d-block">
                  {{ data.value | TIME }}
                </small>
              </template>
              <template #cell(accno)="data">
                <div class="align-items-center d-flex">
                  <span :id="`tooltip_accno${data.index}`">
                    <div>
                      <i
                        :class="`fa ${
                          data.value.type == 'bank'
                            ? 'fa-university'
                            : data.value.type == 'wallet'
                              ? 'fa-credit-card'
                              : 'fa-mobile'
                        } text-${
                          data.value.type == 'bank'
                            ? 'success'
                            : data.value.type == 'wallet'
                              ? 'success'
                              : 'info'
                        }`"
                        class="mr-1"
                      ></i>
                      <strong>
                        {{
                          data.value.type == "wallet"
                            ? data.value.acc
                            : data.value.acc | TRIMTEXT
                        }}
                      </strong>
                      <br />
                      <small
                        v-if="
                          data.value.type == 'wallet' &&
                          data.item.merchantReceiver
                        "
                        class="text-muted"
                      >
                        {{ data.item.merchantReceiver }}
                      </small>
                    </div>
                    <div class="d-block">
                       <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.edit'])">
                        <i
                          v-if="data.value.type == 'mobile' && data.item.transactionStatusId == 6"
                          class="mr-1 fa fa-edit text-info cursor-pointer"
                          @click="mobileNetworkEdit(data.item)"
                        ></i>
                        <!-- <i
                          v-if="data.value.type == 'bank'"
                          class="mr-1 fa fa-edit text-info cursor-pointer"
                          @click="bankAccountEdit(data.item)"
                        ></i> -->
                      </template> 
                      <span
                        class="cursor-pointer"
                        @click="viewAccounts(data.item)"
                      >
                        {{ data.value.no }}
                      </span>
                      <i
                        class="fa fa-copy"
                        v-if="data.value.no != '-'"
                        @click="copyText(data.value.no, 'Account Number')"
                      ></i>
                    </div>
                  </span>
                </div>
                <b-tooltip
                  :target="`tooltip_accno${data.index}`"
                  placement="right"
                  custom-class="customer-tooltip"
                >
                  <div class="tooltip-body p-2 text-left">
                    <h6 class="p-2 border-bottom text-left">
                      {{
                        data.value.type == "wallet"
                          ? "Wallet Details"
                          : "Account Details"
                      }}
                    </h6>
                    <div v-if="data.value.type == 'wallet'">
                      <div class="d-flex">
                        <div class="pb-2 label">Wallet Name:</div>
                        <div class="pb-2 value ml-1">{{ data.value.acc }}</div>
                      </div>
                      <div class="d-flex" v-if="data.item.merchantReceiver">
                        <div class="pb-2 label">Business ID:</div>
                        <div class="pb-2 value ml-1">
                          {{ data.item.merchantReceiver }}
                        </div>
                      </div>
                      <div
                        class="d-flex"
                        v-if="data.item.businessWalletTransactionId"
                      >
                        <div class="pb-2 label">Transaction ID:</div>
                        <div class="pb-2 value ml-1">
                          {{ data.item.businessWalletTransactionId }}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="d-flex">
                        <div class="pb-2 label">Linked Accounts:</div>
                        <div class="pb-2 value ml-1">0</div>
                      </div>
                    </div>
                  </div>
                </b-tooltip>
              </template>

              <template #cell(sourceamount)="data">
                <span
                  class="d-block"
                  v-if="data.value != 'N/A'"
                  v-b-tooltip.hover
                  :title="data.item.country?.countryname"
                >
                  {{ data.value | amountFormat(data.item.sourceCurrencyCode) }}
                </span>
                <span v-else>{{ data.value }}</span>
              </template>
              <template #cell(destamount)="data">
                <span
                  class="d-block"
                  v-if="data.value != 'N/A'"
                  v-b-tooltip.hover
                  :title="data.item.destcountry?.countryname"
                >
                  {{ data.value | amountFormat(data.item.destCurrencyCode) }}
                </span>
                <span v-else>{{ data.value }}</span>
              </template>
              <template #cell(status)="data">
                <div class="d-flex align-items-center">
                  <select
                    class="btn btn-filter badge w-100"
                    :class="data.value.class"
                    v-if="data.value.name == 'Failed'"
                    v-model="data.value.name"
                    @change="transactionProcessPayout(data.item)"
                  >
                    <option selected disabled>{{ data.value.name }}</option>
                    <option value="Retry">Retry</option>
                  </select>
                  <select
                    class="btn btn-filter badge w-100"
                    :class="data.value.class"
                    v-else-if="
                      data.value.name == 'Sent for Payment' ||
                      data.value.name == 'Awaiting Callback'
                    "
                    v-model="data.value.name"
                    @change="statusCheck(data.item)"
                  >
                    <option selected disabled>{{ data.value.name }}</option>
                    <option value="Check status">
                      Check Transaction Status
                    </option>
                  </select>
                  <span v-else class="badge w-100" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                  <!-- <i v-if="data.value.name == 'Failed'" class="fa fa-repeat text-danger"  v-b-tooltip.hover title="Retry"></i> -->
                </div>
              </template>
              <template #cell(payout)="data" v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.process'])">
                <span
                  v-if="['+233205108453', '+233553737149'].includes(data.item.accno.no)"
                  class="badge badge-danger"
                  style="font-size: 0.85em; padding: 0.4em 0.6em;"
                >
                  Suspicious Phone Number
                </span>
                <select
                  v-else
                  class="btn btn-filter badge badge-info"
                  v-model="data.item.payoutProvider"
                  @change="transactionProcessPayout(data.item)"
                  :disabled="
                    data.item.status.name === 'Recipient Paid' ||
                    data.item.status.name === 'In Review' ||
                    data.item.status.name === 'Awaiting Approval' ||
                    data.item.status.name === 'Refunded'
                  "
                >
                  <option value=" " disabled>Select Option</option>
                  <option
                    v-for="(option, index) in getFilteredPayoutOptions(data.item)"
                    :key="index"
                    :value="option"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </template>
              <template #cell(action)="data">
                <!-- Suspicious mobile number - block all actions -->
                <template v-if="['+233205108453', '+233553737149', '+233244370340'].includes(data.item.accno.no)">
                  <span class="badge badge-danger" style="font-size: 0.85em; padding: 0.4em 0.6em;">
                    <i class="fa fa-exclamation-triangle mr-1"></i>Needs Review
                  </span>
                </template>
                <!-- Awaiting Approval - No payout actions allowed -->
                <template
                  v-else-if="
                    data.item.status?.name === 'Awaiting Approval'
                  "
                >
                  <span class="text-muted">-</span>
                </template>
                <!-- Recipient Paid - Limited actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'recipient paid'
                  "
                >
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    right
                    variant="outline-primary"
                    boundary="window"
                  >
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.notification'])">
                      <b-dropdown-item @click="sendNotification(data.item)">
                        Send Notification
                      </b-dropdown-item>
                    </template>
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'Cancelled',
                        )
                      "
                    >
                      Cancel
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.isCaptured == 0"
                      @click="paymentCapture(data.item)"
                    >
                      Payment Capture
                    </b-dropdown-item>
                    <b-dropdown-item @click="trans_status_update(data.item)">
                      Transaction Status Update
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <!-- In Review - Limited actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'in review'
                  "
                >
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    right
                    variant="outline-primary"
                    boundary="window"
                  >
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'Cancelled',
                        )
                      "
                    >
                      Cancel
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'Processing',
                        )
                      "
                    >
                      Un Hold
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.isCaptured == 0"
                      @click="paymentCapture(data.item)"
                    >
                      Payment Capture
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <!-- Awaiting Callback - Limited actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'awaiting callback'
                  "
                >
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    right
                    variant="outline-primary"
                    boundary="window"
                  >
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'Cancelled',
                        )
                      "
                    >
                      Cancel
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="
                        transactionProcessReviewAndCancel(
                          data.item,
                          'In Review',
                        )
                      "
                    >
                      Hold
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.isCaptured == 0"
                      @click="paymentCapture(data.item)"
                    >
                      Payment Capture
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="trans_payout_status_update(data.item)"
                    >
                      Payout Status Update
                    </b-dropdown-item>
                    <b-dropdown-item @click="trans_status_update(data.item)">
                      Transaction Status Update
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.transactionStatusId === 11 && data.item.latestPayoutProviderId !== null && data.item.latestPayoutProviderId !== 'fca8b4a7-b96e-4e54-98e1-2fa7a5019bbe'"
                      @click="manualConfirmSuccess(data.item)"
                    >
                      Transaction Success (Manual Confirm)
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.transactionStatusId === 11 && data.item.latestPayoutProviderId !== null && data.item.latestPayoutProviderId !== 'fca8b4a7-b96e-4e54-98e1-2fa7a5019bbe'"
                      @click="manualConfirmFailed(data.item)"
                    >
                      Transaction Failed (Manual Confirm)
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <!-- Refunded - No actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'refunded'
                  "
                >
                  <span class="text-muted">-</span>
                </template>
                <!-- Awaiting Funds - No actions -->
                <template
                  v-else-if="
                    data.item.status?.name?.toLowerCase() === 'awaiting funds'
                  "
                >
                  <span class="text-muted">-</span>
                </template>
                <!-- All other statuses - Full actions -->
                <template v-else>
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    right
                    variant="outline-primary"
                    boundary="window"
                  >
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.process'])">
                      <b-dropdown-item
                        @click="
                          transactionProcessReviewAndCancel(
                            data.item,
                            'Cancelled',
                          )
                        "
                      >
                        Cancel
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="data.item.status.name != 'In Review'"
                        @click="
                          transactionProcessReviewAndCancel(
                            data.item,
                            'In Review',
                          )
                        "
                      >
                        Hold
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="data.item.status.name == 'In Review'"
                        @click="
                          transactionProcessReviewAndCancel(
                            data.item,
                            'Processing',
                          )
                        "
                      >
                        Un Hold
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.autocapture'])">
                      <b-dropdown-item
                        v-if="data.item.isCaptured == 0"
                        @click="paymentCapture(data.item)"
                      >
                        Payment Capture
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.payoutstatus'])">
                      <b-dropdown-item
                        @click="trans_payout_status_update(data.item)"
                      >
                        Payout Status Update
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.notification'])">
                      <b-dropdown-item @click="sendNotification(data.item)">
                        Send Notification
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.status'])">
                      <b-dropdown-item @click="trans_status_update(data.item)">
                        Transaction Status Update
                      </b-dropdown-item>
                    </template>
                    <template v-if="$store.getters['authpermission/hasAnyPermission'](['transaction.downloadReceipt'])">
                      <b-dropdown-item
                        v-if="
                          data.item.accno.type == 'wallet' &&
                          data.item.businessWalletTransactionId
                        "
                        @click="viewTransactionPDF(data.item)"
                      >
                        Download Receipt
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-if="
                          data.item.accno.type == 'wallet' &&
                          data.item.businessWalletTransactionId
                        "
                        @click="viewReceiptInTab(data.item)"
                      >
                        View Receipt
                      </b-dropdown-item>
                    </template>
                  </b-dropdown>
                </template>
              </template>
            </b-table>
            <b-modal
              id="transactionProcess"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Transaction Process
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(transactionProcessSubmit)">
                    <ValidationProvider
                      name="reason"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            transactionProcess.reason &&
                            transactionProcess.reason.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="reason">Select Reason*</label>
                          <multiselect
                            placeholder=""
                            v-model="transactionProcess.reason"
                            :show-labels="false"
                            :options="transactionReasons"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              transactionProcess.reason &&
                              transactionProcess.reason.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="refund_method"
                      rules="required"
                      v-slot="{ errors }"
                      v-if="transactionProcess.status == 'Cancelled'"
                    >
                      <div class="country-dropdown">
                        <div
                          class="form-group form-select multiselect-grp"
                          :class="{
                            errors: errors[0],
                            success:
                              transactionProcess.refundmethod &&
                              transactionProcess.refundmethod.length != 0 &&
                              !errors[0],
                          }"
                        >
                          <span class="float-label">
                            <label for="refund_method">
                              Select Refund Method*
                            </label>
                            <multiselect
                              placeholder=""
                              v-model="transactionProcess.refundmethod"
                              :show-labels="false"
                              :options="refund_method_Options"
                              :searchable="false"
                            ></multiselect>
                            <i
                              class="fa fa-times"
                              v-if="errors.length && errors[0]"
                            ></i>
                            <i
                              class="fa fa-check"
                              v-if="
                                transactionProcess.refundmethod &&
                                transactionProcess.refundmethod.length != 0 &&
                                !errors[0]
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !transactionProcess.comment,
                          success: transactionProcess.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="transactionProcess.comment"
                            class="form-control"
                            id="comment"
                            placeholder="comment*"
                          ></textarea>
                          <label for="comment" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !transactionProcess.comment"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="transactionProcess.comment"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="transactionProcessClearData()"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="transactionNotification"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Send Notification
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(transactionNotificationSubmit)">
                    <ValidationProvider
                      name="notification_type"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            notification.type &&
                            notification.type.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="notification_type">
                            Notification Type*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="notification.type"
                            :show-labels="false"
                            :options="notificationTypeOptions"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              notification.type &&
                              notification.type.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="notification_action"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            notification.action &&
                            notification.action.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="notification_action">
                            Notification Action*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="notification.action"
                            :show-labels="false"
                            :options="notificationActionOptions"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              notification.action &&
                              notification.action.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="notification_custom"
                      rules="required"
                      v-slot="{ errors }"
                      v-if="notification.action == 'Other'"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors:
                            (errors.length && !notification.custom) ||
                            errors[0],
                          success: notification.custom && !errors[0],
                        }"
                      >
                        <span class="float-label mb-1">
                          <textarea
                            class="form-control"
                            id="notification_custom"
                            v-model="notification.custom"
                            placeholder=" "
                          ></textarea>
                          <label
                            for="notification_custom"
                            class="control-label"
                          >
                            Custom Notification Text*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="
                              (errors.length && !notification.custom) ||
                              errors[0]
                            "
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="notification.custom && !errors[0]"
                          ></i>
                        </span>
                        <span class="text-danger">
                          <b>Note :-</b>
                          List of Placeholders: [trans_ref_#], [cust_name],
                          [trans_receiver]
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('transactionNotification')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="transactionStatusUpdate"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Transaction Status Update
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form
                    @submit.prevent="passes(statusUpdateSubmit('transaction'))"
                  >
                    <ValidationProvider
                      name="transaction_status"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            transactionStatusUpdate.status &&
                            transactionStatusUpdate.status.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="transaction_status">
                            Transaction Status*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="transactionStatusUpdate.status"
                            :show-labels="false"
                            :options="UpdateStatusoption"
                            label="status"
                            track-by="status"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              transactionStatusUpdate.status &&
                              transactionStatusUpdate.status.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="form-group">
                      <span class="float-label mb-1">
                        <textarea
                          class="form-control"
                          id="transaction_cashflow"
                          v-model="transactionStatusUpdate.comment"
                          placeholder=" "
                        ></textarea>
                        <label for="transaction_cashflow" class="control-label">
                          Comment*
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('transactionStatusUpdate')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="IBDStatusUpdate"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  IBD Status Update
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(statusUpdateSubmit('IBD'))">
                    <ValidationProvider
                      name="IBD_status"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            IBDStatusUpdate &&
                            IBDStatusUpdate.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="IBD_status">IBD Status*</label>
                          <multiselect
                            placeholder=""
                            v-model="IBDStatusUpdate"
                            :show-labels="false"
                            :options="IBDStatusoption"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              IBDStatusUpdate &&
                              IBDStatusUpdate.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('IBDStatusUpdate')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="payoutStatusUpdate"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Payout Status Update
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form
                    @submit.prevent="
                      passes(statusUpdateSubmit('payout_status'))
                    "
                  >
                    <ValidationProvider
                      name="transactionpayout_status"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: payoutStatusUpdate.provider && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="transactionpayout_status">
                            Select Provider*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="payoutStatusUpdate.provider"
                            :show-labels="false"
                            :options="provideroption"
                            label="name"
                            track-by="providerid"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="payoutStatusUpdate.provider && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="form-group">
                      <span class="float-label mb-1">
                        <textarea
                          class="form-control"
                          id="transaction_comment"
                          v-model="payoutStatusUpdate.comment"
                          placeholder=" "
                        ></textarea>
                        <label for="transaction_comment" class="control-label">
                          Comment*
                        </label>
                        <div class="line"></div>
                      </span>
                    </div>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('payoutStatusUpdate')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <b-modal
              id="transaction_comment"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">Comment</h5>
                <!-- {{comment_transaction.type}}  -->
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(commentSubmit())">
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !comment_transaction.comment,
                          success: comment_transaction.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="comment_transaction.comment"
                            class="form-control"
                            id="comment"
                            placeholder="comment*"
                          ></textarea>
                          <label for="comment" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !comment_transaction.comment"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="comment_transaction.comment"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('transaction_comment')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Manual Confirm Modal -->
            <b-modal
              id="manualConfirmModal"
              size="md"
              no-stacking
              no-close-on-backdrop
              hide-footer
              hide-header-close
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  {{ manualConfirm.title }} — {{ manualConfirm.reference_number }}
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(manualConfirmSubmit)">
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !manualConfirm.comment,
                          success: manualConfirm.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            v-model="manualConfirm.comment"
                            class="form-control"
                            id="manual_confirm_comment"
                            placeholder=" "
                          ></textarea>
                          <label for="manual_confirm_comment" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i class="fa fa-times" v-if="errors.length && !manualConfirm.comment"></i>
                          <i class="fa fa-check" v-if="manualConfirm.comment"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div class="d-flex flex-column flex-md-row justify-content-center">
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('manualConfirmModal')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        :disabled="!manualConfirm.comment"
                      >
                        OK
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Edit Mobile Network -->
            <b-modal
              id="editMobileNetwork"
              size="md"
              title="Edit Number and Network"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Edit Number and Network
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }" class="body">
                  <form @submit.prevent="passes(updateMobileNetwork)">
                    <ValidationProvider
                      name="network"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: updateMobile.network && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="network">Select Network Name</label>
                          <multiselect
                            placeholder=""
                            v-model="updateMobile.network"
                            :show-labels="false"
                            :options="network_options"
                            label="name"
                            track-by="id"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateMobile.network && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <!-- <ValidationProvider
                      name="phoneNumber"
                      :rules="'required'"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: mobileInputError == false,
                          success: updateMobile.phoneNumber && mobileInputError,
                        }"
                      >
                        <div class="float-label">
                          <label for="primary_number" class="control-label">
                            Mobile*
                          </label>
                          <vue-tel-input
                            v-model="updateMobile.phoneNumber"
                            v-bind="primaryMobileNumber"
                            @validate="mobileInputValidate"
                            ref="telInput"
                            @keydown.native="restrictSpecialCharacter($event)"
                            @paste.native="handlePhonePaste($event)"
                          >
                            <template v-slot:arrow-icon>
                              <span class="vti__dropdown-arrow">{{ "▼" }}</span>
                            </template>
                          </vue-tel-input>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="
                              mobileInputError == false || isDisplayPhoneError
                            "
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="mobileInputError && updateMobile.phoneNumber"
                          ></i>
                        </div>
                        <span
                          class="text-danger error-msg"
                          v-if="errors && isDisplayPhoneError"
                        >
                          {{ errors[0] }}
                        </span>
                      </div>
                    </ValidationProvider> -->
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !updateMobile.comment,
                          success: updateMobile.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="updateMobile.comment"
                            class="form-control"
                            id="comment"
                            placeholder="comment*"
                          ></textarea>
                          <label for="comment" class="control-label">
                            Comment*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !updateMobile.comment"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateMobile.comment"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="
                          $bvModal.hide('editMobileNetwork');
                          isDisplayPhoneError = false;
                        "
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        @click="isDisplayPhoneError = true"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Edit Bank Account -->
            <b-modal
              id="editBankAccount"
              size="md"
              title="Edit Bank Account"
              no-stacking
              no-close-on-backdrop
              hide-footer
            >
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Edit Bank Account
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }" class="body">
                  <form @submit.prevent="passes(updateBankAccount)">
                    <ValidationProvider
                      name="bank"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group form-select single-multiselect select-option-custom"
                        :class="{
                          errors: errors[0],
                          success: updateBank.bank && !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="bank">Select Bank Name</label>
                          <multiselect
                            placeholder=""
                            v-model="updateBank.bank"
                            :show-labels="false"
                            :options="bank_options"
                            label="name"
                            track-by="name"
                          >
                          </multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateBank.bank && !errors[0]"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="account"
                      :rules="'required'"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors:  errors.length && !updateBank.account,
                          success: updateBank.account,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="updateBank.account"
                            class="form-control"
                            id="account"
                            placeholder="Account Number*"
                          />
                          <label for="account" class="control-label"
                            >Account Number*</label
                          >
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !updateBank.account"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateBank.account"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="comment"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !updateBank.comment,
                          success: updateBank.comment,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="updateBank.comment"
                            class="form-control"
                            id="comment"
                            placeholder="comment*"
                          ></textarea>
                          <label for="comment" class="control-label"
                            >Comment*</label
                          >
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !updateBank.comment"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="updateBank.comment"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="
                          $bvModal.hide('editBankAccount');
                        "
                        >Cancel</b-button
                      >
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                        >Submit</b-button
                      >
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go to Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
            <!--<div class="mt-5">
              <strong>Total Number of Transactions:4</strong>
              <span class="d-block"
                ><strong>NOTE:</strong>The number of transactions in the report
                is limited to 100</span
              >
              <div class="d-block d-md-flex justify-content-between w-50 mb-4">
                <div class="d-flex flex-column mt-4">
                  <span class="font-weight-bold">Remitter to Pay</span>
                  <span>AUD 4350.19</span>
                </div>
                <div class="d-flex flex-column mt-4">
                  <span class="font-weight-bold">Total Source Amount</span>
                  <span>AUD 4350.19</span>
                </div>
                <div class="d-flex flex-column mt-4">
                  <span class="font-weight-bold">Commission</span>
                  <span>AUD 4350.19</span>
                </div>
              </div>
              <div class="d-flex flex-column mb-4 mt-4">
                <span class="font-weight-bold">Total Deduction</span>
                <span>AUD 4350.19</span>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bold">Total Dest Amount</span>
                <span>AUD 4350.19</span>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="show-details"
      size="lg"
      class="transaction-lg-modal"
      title="Transaction Details"
      hide-footer
      no-stacking
      no-close-on-backdrop
    >
      <div v-if="detailsstatus" class="modal-area">
        <div class="transaction-details-body">
          <h6 class="text-danger">{{ errorMsg }}</h6>
        </div>
      </div>
      <div v-if="!detailsstatus" class="modal-area">
        <div class="row">
          <div class="col-md-6">
            <ul class="list-unstyled mb-0 mr-2">
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Sender Name:</span>
                  <span class="ml-2">{{ transactionDetail.sendername }}</span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Merchant Ref. No.:</span>
                  <span class="ml-2">{{ transactionDetail.refno }}</span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Source Amount:</span>
                  <span class="ml-2">{{ transactionDetail.srcamount }}</span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Transaction Status:</span>
                  <span class="ml-2">{{ transactionDetail.transStatus }}</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="list-unstyled mb-0">
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Beneficiary Name:</span>
                  <span class="ml-2">
                    {{ transactionDetail.beneficiaryname }}
                  </span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Account No.:</span>
                  <span class="ml-2">
                    {{ transactionDetail.accName }} /
                    {{ transactionDetail.accNumber }}
                  </span>
                </p>
              </li>
              <li class="border-bottom py-3">
                <p class="mb-0 font-16 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Dest. Amount:</span>
                  <span class="ml-2">{{ transactionDetail.destamount }}</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div class="transaction-raw-details-body max-width">
          <ul
            class="list-unstyled mb-0"
            v-for="item in this.transactionDetail.details"
            :key="item.id"
          >
            <!-- <span>{{item.transactionDate}}</span> -->
            <span v-if="item.transactionDate">
              <li>
                <p class="mb-0 font-12 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Trans. ID:</span>
                  <span class="ml-2">{{ item.transactionid }}</span>
                </p>
              </li>
              <li>
                <p class="mb-0 font-12 d-flex align-items-center">
                  <span class="font-weight-bold w-30">Provider Name:</span>
                  <span class="ml-2 badge-danger">
                    {{ item.provider_name }}
                  </span>
                </p>
              </li>
              <!-- <li class="mb-2">
                                <p class="mb-0 font-12 d-flex align-items-center">
                                    <span class="font-weight-bold w-30">Trans. Status:</span>
                                    <span class="ml-2" v-if="item.status == '0'">Initial Request</span>
                                    <span class="ml-2" v-if="item.status == '1'">Callback Pending</span>
                                    <span class="ml-2" v-if="item.status == '2'">Success</span>
                                    <span class="ml-2" v-if="item.status == '3'">Failed</span>
                                    <span class="ml-2" v-if="item.status == '4'">Callback Failed</span>
                                    <span class="ml-2" v-if="item.status == '5'">Callback Success</span>
                                </p>
                            </li> -->
              <span
                v-if="
                  item.provider_name != 'Terrapay' ||
                  item.terrapay_reqs.length == 0
                "
              >
                <li>
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Trans. Date:</span>
                    <span class="ml-2">
                      {{ convertDate(item.transactionDate) }}
                    </span>
                  </p>
                </li>
                <li>
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Request Date:</span>
                    <span class="ml-2">{{ convertDate(item.createdAt) }}</span>
                  </p>
                </li>
                <li>
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Raw Request:</span>
                    <span class="ml-2 scroll" v-if="item.raw_request">
                      {{ item.raw_request }}
                      <button
                        @click="copyValue(item.raw_request)"
                        title="copy to clipboard"
                      >
                        <i class="fa fa-copy"></i>
                      </button>
                    </span>
                    <span class="ml-2" v-if="!item.raw_request">N/A</span>
                  </p>
                </li>
                <li>
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Response Date:</span>
                    <span class="ml-2">{{ convertDate(item.updatedAt) }}</span>
                  </p>
                </li>
                <li>
                  <!-- class="py-3" -->
                  <p class="mb-0 font-12 d-flex align-items-center">
                    <span class="font-weight-bold w-30">Response:</span>
                    <span
                      class="ml-2 scroll"
                      :class="[
                        item.providerResponse.error ? 'badge-danger' : '',
                      ]"
                      v-if="item.providerResponse"
                    >
                      {{ convertToString(item.providerResponse) }}
                      <button
                        @click="copyValue(item.providerResponse)"
                        title="copy to clipboard"
                      >
                        <i class="fa fa-copy"></i>
                      </button>
                    </span>
                    <span class="ml-2" v-if="!item.providerResponse">N/A</span>
                  </p>
                </li>
              </span>
              <span
                v-if="
                  item.provider_name == 'Terrapay' &&
                  item.terrapay_reqs.length != 0
                "
              >
                <!-- <h6 v-if="item.terrapay_reqs.length == 0">Not Available</h6> -->
                <span
                  v-for="terrapay in item.terrapay_reqs"
                  :key="terrapay.transaction_ref"
                >
                  <li>
                    <p class="mb-0 font-12 d-flex align-items-center">
                      <span class="font-weight-bold w-30">Trans. Date:</span>
                      <span class="ml-2">
                        {{ convertDate(terrapay.created_at) }}
                      </span>
                    </p>
                  </li>
                  <li>
                    <p class="mb-0 font-12 d-flex align-items-center">
                      <span class="font-weight-bold w-30">Raw Request:</span>
                      <span class="ml-2 scroll" v-if="terrapay.raw_request">
                        {{ terrapay.raw_request }}
                        <button
                          @click="copyValue(terrapay.raw_request)"
                          title="copy to clipboard"
                        >
                          <i class="fa fa-copy"></i>
                        </button>
                      </span>
                      <span class="ml-2" v-if="!terrapay.raw_request">N/A</span>
                    </p>
                  </li>
                  <li class="py-3">
                    <p class="mb-0 font-12 d-flex align-items-center">
                      <span class="font-weight-bold w-30">Response:</span>
                      <span
                        class="ml-2 scroll"
                        :class="[
                          terrapay.raw_response.error ? 'badge-danger' : '',
                        ]"
                        v-if="terrapay.raw_response"
                      >
                        {{ convertToString(terrapay.raw_response) }}
                        <button
                          @click="copyValue(terrapay.raw_response)"
                          title="copy to clipboard"
                        >
                          <i class="fa fa-copy"></i>
                        </button>
                      </span>
                      <span class="ml-2" v-if="!terrapay.raw_response">
                        N/A
                      </span>
                    </p>
                  </li>
                </span>
              </span>
              <hr />
            </span>
          </ul>
        </div>
      </div>
    </b-modal>
    <CustomerDetailsModel :customerid="customerDetail" />
    <RefundRemitterCredit :remitterCredit="remitterCredit" />
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
// const { VueTelInput } = require("vue-tel-input");
import parsePhoneNumber from "libphonenumber-js";
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "vue-select/dist/vue-select.css";
import CustomerDetailsModel from "../../core/CustomerDetailsModel.vue";
import RefundRemitterCredit from "../../core/RefundRemitterCredit.vue";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
const moment = require("moment");
import Multiselect from "vue-multiselect";
import shared from "@/shared.js";
import {
  GET_TRANSACTION_LIST,
  GET_PROVIDER_LIST,
  PROCESS_TRANSACTIONS,
  UPDATE_PAYOUT_STATUS,
  GET_TRANSACTION_STATUS,
  UPDATE_TRANSACTION_STATUS,
  MANUAL_SUCCESS_TRANSACTION,
  MANUAL_FAIL_TRANSACTION,
  TRANSACTION_MOMO_NETWORKS,
  TRANSACTION_PAYMENT_CAPTURE,
  CHECK_TRANSACTION_STATUS,
  UPDATE_TRANSACTION_MOMO_NUMBER,
  TRANSACTION_BANK_LIST,
  UPDATE_TRANSACTION_BANK_ACCOUNT,
  COUNTRYLIST,
} from "../../../store/actions.type.js";
import { mapGetters } from "vuex";
import { myFunction } from "@/common/common-helper.js";
export default {
  name: "MiddlewareTransactionListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Datepicker: () => import("vuejs-datepicker"),
    "v-select": () => import("vue-select"),
    Multiselect,
    // VueTelInput,
    "main-loader": LoaderComponent,
    CustomerDetailsModel,
    RefundRemitterCredit,
    ValidationObserver,
    ValidationProvider,
  },
  methods: {
    // Filter payout options based on reference number and transaction details
    getFilteredPayoutOptions(item) {
      // Handle backward compatibility - if item is a string (old usage), treat as reference number
      const referenceNumber = typeof item === 'string' ? item : item?.custRefno;
      const sourceCurrency = typeof item === 'object' ? item?.sourceCurrencyCode : null;
      const paymentMethodId = typeof item === 'object' ? item?.paymentMethodId : null;
      const transactionStatus = typeof item === 'object' ? item?.status?.name : null;

      // Check for EUR currency with specific payment method and Awaiting Funds status - show only "Funds Received"
      if (sourceCurrency === 'EUR' &&
          paymentMethodId === this.EUR_FUNDS_RECEIVED_PAYMENT_METHOD_ID &&
          transactionStatus === this.EUR_FUNDS_RECEIVED_STATUS) {
        // Return custom "Funds Received" option
        return [{
          name: 'Funds Received',
          providerid: 'FUNDS_RECEIVED_STATUS',
          id: 'FUNDS_RECEIVED_STATUS'
        }];
      }

      // If reference number starts with 'PW', show only 'Wallet' option regardless of status
      if (referenceNumber && referenceNumber.startsWith('PW')) {
        return this.payoutoption.filter(option =>
          option.name && option.name.toLowerCase().includes('wallet')
        );
      }

      // Otherwise, show all payout options
      return this.payoutoption;
    },
    mobileInputValidate(phoneObject) {
      this.mobileInputError = phoneObject.valid;
    },
    restrictSpecialCharacter(e) {
      if (
        /[^0-9]/.test(e.key) &&
        !["Backspace", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)
      ) {
        e.preventDefault();
      }
    },
    handlePhonePaste(e) {
      // Prevent default paste behavior
      e.preventDefault();

      // Get pasted text from clipboard
      const pastedText = (e.clipboardData || window.clipboardData).getData('text');

      // Strip leading + if it exists
      const cleanedText = pastedText.replace(/^\+/, '');

      // Get the input element
      const input = e.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      // Get current value
      const currentValue = this.updateMobile.phoneNumber || '';

      // Insert cleaned text at cursor position
      const newValue = currentValue.substring(0, start) + cleanedText + currentValue.substring(end);

      // Update the v-model
      this.updateMobile.phoneNumber = newValue;

      // Set cursor position after pasted text
      this.$nextTick(() => {
        input.setSelectionRange(start + cleanedText.length, start + cleanedText.length);
      });
    },
    // get All Mobile netowrks
    async getAllMobilenetworks(country_id) {
      // momo/provider-list?countryid=8ee2b557-1047-49c4-bac2-ee7bf35e24e3&currency=GHS
      let params = `?countryid=${country_id}`;
      this.network_options = [];
      await this.$store
        .dispatch(TRANSACTION_MOMO_NETWORKS, params)
        .then((response) => {
          if (response.status == 200) {
            this.network_options = response.data.details;
          }
        });
    },
    // edit mobile network for single transaction
    async mobileNetworkEdit(data) {
      // Check if destination country data exists
      if (!data.destcountry || !data.destcountry.countryid) {
        myFunction.showInfo("Destination country information is missing", "error");
        return;
      }

      await this.getAllMobilenetworks(data.destcountry.countryid);
      this.updateMobile.id = data.id;
      this.updateMobile.countryCode = data.destcountry.mobilecountrycode;
      this.updateMobile.network = this.network_options.filter(
        (item) => item.name === data.accno.acc,
      )[0];
      this.updateMobile.comment = "";
      let mobilenumber = "";
      this.primaryMobileNumber = {
        mode: "auto",
        defaultCountry: data.destcountry.isocode,
        autoFormat: false,
        dropdownOptions: {
          showFlags: true,
          disabled: true,
          showDialCodeInSelection: true,
        },
      };
      if (data.accno.no != "-") {
        try {
          const phoneNumber = parsePhoneNumber(
            data.accno.no,
            data.destcountry.isocode,
          );
          mobilenumber = phoneNumber.nationalNumber;
        } catch (error) {
          // If parsing fails, display the number as-is (removing country code for display)
          // This handles cases with duplicate country codes like +233+233558252791
          mobilenumber = data.accno.no.replace(data.destcountry.mobilecountrycode, "").trim();
        }
      }
      this.updateMobile.phoneNumber = mobilenumber;
      this.$bvModal.show("editMobileNetwork");
    },
    // Update Transaction momo munber
    updateMobileNetwork() {
      if (!this.mobileInputError) {
        this.isDisplayPhoneError = true;
        return;
      } else {
        this.isDisplayPhoneError = false;

        // Construct the full mobile number
        const fullMobileNumber = this.updateMobile.countryCode + this.updateMobile.phoneNumber;

        // Check for duplicate country code in the phone number
        // Pattern: country code appears twice consecutively (e.g., +233+233 or +233233)
        const countryCodePattern = this.updateMobile.countryCode.replace('+', '\\+');
        const duplicatePattern = new RegExp(`^${countryCodePattern}[+]?${countryCodePattern.replace('\\+', '')}`);

        if (duplicatePattern.test(fullMobileNumber)) {
          myFunction.showInfo(
            "Invalid phone number: Country code is duplicated. Please correct the phone number.",
            "error"
          );
          return;
        }

        // Additional validation: check if phone number already starts with country code
        if (this.updateMobile.phoneNumber.startsWith(this.updateMobile.countryCode) ||
            this.updateMobile.phoneNumber.startsWith(this.updateMobile.countryCode.replace('+', ''))) {
          myFunction.showInfo(
            "Invalid phone number: Phone number already contains the country code. Please enter only the national number.",
            "error"
          );
          return;
        }

        let params = {
          transactionid: this.updateMobile.id,
          momoproviderid: this.updateMobile.network.id,
          // mobile_number: fullMobileNumber,
          comment: this.updateMobile.comment,
        };
        this.$store
          .dispatch(UPDATE_TRANSACTION_MOMO_NUMBER, params)
          .then((response) => {
            if (response.status == 200) {
              myFunction.showInfo(response.data.message, "success");
              this.isDisplayPhoneError = false;
              this.$bvModal.hide("editMobileNetwork");
              this.getTransactionList();
            } else {
              if (response.data.detail) {
                myFunction.showInfo(response.data.detail, "error");
              } else {
                myFunction.showInfo(response.data.message, "error");
              }
            }
          });
      }
    },
    // redirect transaction Details
    transactionDetails(data) {
      const route = this.$router.resolve({
        name: "transaction-details",
        params: {
          ref_no: this.$CryptoJS.AES.encrypt(
            data.custRefno,
            "ref_no",
          ).toString(),
          transaction_id: this.$CryptoJS.AES.encrypt(
            data.id,
            "transaction_id",
          ).toString(),
        },
      });
      window.open(route.href, "_blank");
    },
    // View accounts
    viewAccounts(data) {
      let params = {};
      if (data.accno.type == "bank") {
        params.name = "Bank Account";
        params.value = data.accno.no;
      }
      if (data.accno.type == "mobile") {
        params.name = "MOMO Account";
        params.value = data.accno.no;
      }
      if (data.accno.type == "wallet") {
        params.name = "Wallet Account";
        params.value = data.accno.no;
      }
      this.$router.push({
        path: "/accounts/edit",
        query: {
          name: this.$CryptoJS.AES.encrypt(params.name, "name").toString(),
          value: this.$CryptoJS.AES.encrypt(params.value, "value").toString(),
        },
      });
    },
    // get provider list
    async getProvider() {
      let params = ``;
      await this.$store.dispatch(GET_PROVIDER_LIST, params).then((response) => {
        if (response.status == 200) {
          this.payoutoption = response.data.details.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
          this.provideroption = response.data.details.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
        }
      });
    },
    // for add comment on cancel and hold
    commentSubmit() {
      console.log(this.comment_transaction);
    },
    // for refund
    refund(item) {
      ((this.remitterCredit = {
        customer: item.sender.name,
        comment: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        amount: item.destamount?.destamount?.split(" ")[1],
        creditType: "",
        refundType: "Orignal Method",
      }),
        this.$bvModal.show("refund-Remitter-credit"));
    },
    transaction_comments(type) {
      this.comment_transaction.type = type;
      this.$bvModal.show("transaction_comment");
    },
    // for payout filters
    selectPayout() {
      setTimeout(() => {
        this.payoutSourceOption = [];
        this.advanceFilters.filter(
          (data) => data.field.id == "payout_source",
        )[0].payout.source = "";
      }, 100);
    },
    searchPayoutSource(event) {
      if (event.length > 0) {
        if (
          this.advanceFilters.filter(
            (data) => data.field.id == "payout_source",
          )[0].payout.type.value == "IBOBank"
        ) {
          this.payoutSourceOption = this.banks;
        }
        if (
          this.advanceFilters.filter(
            (data) => data.field.id == "payout_source",
          )[0].payout.type.value == "mobilemoney"
        ) {
          this.payoutSourceOption = this.mobileNetworks;
        }
      } else {
        this.payoutSourceOption = [];
      }
    },
    bulkSelectall() {
      setTimeout(() => {
        this.transactions.map((item) => {
          item.selected = this.selectAll;
        });
      }, 1);
    },
    showalertForbulkcapture() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to Change for all transactions ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                icon: "success",
                confirmButtonText: "Done",
              })
              .then(() => {
                this.bulkCapturestatus = "";
                this.$refs.transactionTable.refresh();
              });
          }
        });
    },
    statusBadges(item) {
      const transactionStatus = item ? item : "N/A";
      let status = { name: "N/A", class: "badge-grey-solid" };

      // New color scheme
      if (transactionStatus == "Success") {
        status = { name: "Success", class: "badge badge-success-solid" };
      } else if (transactionStatus == "Failed") {
        status = { name: "Failed", class: "badge badge-danger-solid" };
      } else if (transactionStatus == "Pending") {
        status = { name: "Pending", class: "badge badge-warning-solid" };
      } else if (transactionStatus == "Processing") {
        status = { name: "Processing", class: "badge badge-warning-solid" };
      } else if (transactionStatus == "Incomplete") {
        status = { name: "Incomplete", class: "badge badge-secondary" };
      } else if (transactionStatus == "Cancelled") {
        status = { name: "Cancelled", class: "badge badge-secondary" };
      } else if (transactionStatus == "Refunded") {
        status = { name: "Refunded", class: "badge badge-info-solid" };
      } else if (transactionStatus == "In Progress") {
        status = { name: "In Progress", class: "badge badge-primary-solid" };
      } else if (transactionStatus == "Awaiting Funds") {
        status = { name: "Awaiting Funds", class: "badge badge-warning-solid" };
      } else if (transactionStatus == "Funds Received") {
        status = { name: "Funds Received", class: "badge badge-info-solid" };
      } else if (transactionStatus == "Sent for Payment") {
        status = {
          name: "Sent for Payment",
          class: "badge badge-primary-solid",
        };
      } else if (transactionStatus == "Recipient Paid") {
        status = { name: "Recipient Paid", class: "badge badge-success-solid" };
      } else if (transactionStatus == "In Review") {
        status = { name: "In Review", class: "badge badge-warning-solid-2" };
      } else {
        status = { name: transactionStatus, class: "badge badge-secondary" };
      }
      return status;
    },
    // transaction capture
    paymentCapture(data) {
      // this.showAlertTop=!this.showAlertTop;
      let params = {
        transaction_id: data.id,
      };
      this.$store
        .dispatch(TRANSACTION_PAYMENT_CAPTURE, params)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.getTransactionList();
          } else {
            if (response.data.message) {
              myFunction.showInfo(response.data.message, "error");
            } else {
              myFunction.showInfo(response.data.detail, "error");
            }
          }
        });
    },
    // transaction status check
    statusCheck(data) {
      let params = {
        transaction_id: data.id,
      };
      this.$store
        .dispatch(CHECK_TRANSACTION_STATUS, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            // Map API response code to transaction status
            let transactionStatus = "Awaiting Callback"; // Default status

            if (response.data.code === "SUCCESS") {
              transactionStatus = "Recipient Paid";
            } else if (
              response.data.code === "FAILED" ||
              response.data.code === "Failed"
            ) {
              transactionStatus = "Failed";
            }
            // If code is neither SUCCESS nor FAILED, keep "Awaiting Callback"

            // Update the transaction status in the list
            this.transactions.filter((item) => item.id == data.id)[0].status =
              this.statusBadges(transactionStatus);
          } else {
            this.transactionProcessClearData();
            if (response.data.message) {
              myFunction.showInfo(response.data.message, "error");
            } else {
              myFunction.showInfo(response.data.detail, "error");
            }
          }
        });
    },
    // transaction Process for Payout
    transactionProcessPayout(data) {
      // this.transactionProcess.transaction_id = data.id;
      // this.transactionProcess.status = data.status;
      // if(this.transactionProcess.status.name == "Sent for Payment"){
      //     if(data.payoutStatus){
      //         this.transactionProcess.providerid = data.payoutStatus;
      //         this.transactionProcessSubmit();
      //     } else {
      //         this.transactionProcessClearData();
      //         myFunction.showInfo('Payout must be set to send for payment', "error");
      //     }
      // } else {
      //     this.$bvModal.show('transactionProcess');
      // }
      if (data.payoutProvider) {
        // Check if this is EUR currency with specific payment method, Awaiting Funds status, and "Funds received" option
        const isEURSpecialCase =
          data.sourceCurrencyCode === 'EUR' &&
          data.paymentMethodId === this.EUR_FUNDS_RECEIVED_PAYMENT_METHOD_ID &&
          data.status?.name === this.EUR_FUNDS_RECEIVED_STATUS &&
          data.payoutProvider.name &&
          data.payoutProvider.name.toLowerCase().includes('funds received');

        const swalWithBootstrapButtons = this.$swal.mixin({
          customClass: {
            confirmButton: "btn btn-primary btn-lg my-3",
            cancelButton: "btn btn-outline-secondary btn-lg",
          },
          buttonsStyling: false,
        });

        // Show custom sweetalert for EUR special case with "Funds received"
        if (isEURSpecialCase) {
          swalWithBootstrapButtons.fire({
            title: "Funds Received",
            text: "Are you sure that the funds have been received?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          }).then((result) => {
            if (result.isConfirmed) {
              // Call transaction status update API
              let params = {
                transaction_id: data.id,
                transaction_status: "Funds Received"
              };
              this.$store
                .dispatch(UPDATE_TRANSACTION_STATUS, params)
                .then((response) => {
                  if (response.status == 200) {
                    myFunction.showInfo(response.data.message, "success");
                    // Reset the dropdown value before refreshing
                    data.payoutProvider = " ";
                    this.getTransactionList();
                  } else {
                    myFunction.showInfo(response.data.message, "error");
                  }
                  this.transactionProcessClearData();
                });
            } else {
              // Reset the dropdown value on cancel
              data.payoutProvider = " ";
              this.transactionProcessClearData();
            }
          });
        } else {
          // Standard confirmation flow for all other cases
          swalWithBootstrapButtons
            .fire({
              title: "Are you sure?",
              text: "Confirm Transaction",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.transactionProcess.transaction_id = data.id;
                this.transactionProcess.status = "Sent for Payment";
                this.transactionProcess.providerid =
                  data.payoutProvider.providerid;
                this.transactionProcessSubmit();
              } else {
                this.transactionProcessClearData();
              }
            });
        }
      } else {
        this.transactionProcessClearData();
        myFunction.showInfo("Payout must be set to send for payment", "error");
      }
    },
    // transaction Process for review and cancel
    transactionProcessReviewAndCancel(data, type) {
      this.transactionProcess.transaction_id = data.id;
      this.transactionProcess.status = type;
      if (type == "Cancelled") {
        this.transactionReasons = [
          "Duplicate",
          "Compliance",
          "Payment Method",
          "Payout Method",
          "Incorrect Sender",
          "Incorrect Amount",
        ];
      } else {
        this.transactionReasons = ["CE Hold", "Compliance Hold"];
      }
      if (type == "Processing") {
        this.transactionProcessSubmit();
      } else {
        this.$bvModal.show("transactionProcess");
      }
    },
    transactionProcessClearData() {
      this.transactions = JSON.parse(JSON.stringify(this.transactionsCopy));
      this.transactionProcess.transaction_id = "";
      this.transactionProcess.status = "";
      this.transactionProcess.reason = "";
      this.transactionProcess.refundmethod = "";
      this.transactionProcess.comment = "";
      this.transactionProcess.providerid = "";
      this.$bvModal.hide("transactionProcess");
    },
    // transaction Process submit api
    transactionProcessSubmit() {
      let params = {
        transaction_id: this.transactionProcess.transaction_id,
        transaction_status: this.transactionProcess.status,
      };
      if (
        this.transactionProcess.status == "In Review" ||
        this.transactionProcess.status == "Cancelled"
      ) {
        params.reason = this.transactionProcess.reason;
        params.comment = this.transactionProcess.comment;
      }
      if (this.transactionProcess.status == "Cancelled") {
        params.refund_method = this.transactionProcess.refundmethod;
      }
      if (this.transactionProcess.status == "Sent for Payment") {
        params.provider = this.transactionProcess.providerid;
      }
      this.$store.dispatch(PROCESS_TRANSACTIONS, params).then((response) => {
        if (response.status == 200) {
          const code = response.data.code;
          if (code === "FAILED") {
            this.transactionProcessClearData();
            myFunction.showInfo(response.data.message, "error");
          } else {
            myFunction.showInfo(response.data.message, "success");
            this.getTransactionList();
            this.$bvModal.hide("transactionProcess");
          }
        } else {
          this.transactionProcessClearData();
          if (response.data.message) {
            myFunction.showInfo(response.data.message, "error");
          } else {
            myFunction.showInfo(response.data.detail, "error");
          }
        }
      });
    },
    transactionNotificationSubmit() {
      console.log("transactionNotificationSubmit", this.notification);
    },
    sendNotification(data) {
      console.log(data);
      this.$bvModal.show("transactionNotification");
    },
    trans_status_update(data) {
      // console.log(data);
      this.getTransactionStatus();
      this.transactionStatusUpdate.transaction_id = data.id;
      this.transactionStatusUpdate.status = "";
      this.transactionStatusUpdate.comment = "";
      this.$bvModal.show("transactionStatusUpdate");
    },
    async viewTransactionPDF(data) {
      try {
        if (!data.businessWalletTransactionId) {
          this.$toast.error("Transaction ID not found");
          return;
        }

        const response = await this.$http.get(
          `transaction/transaction/${data.businessWalletTransactionId}`,
          {
            responseType: "blob",
          },
        );

        // Create blob URL and download
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `transaction_receipt_${data.businessWalletTransactionId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$toast.success("Receipt downloaded successfully");
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.$toast.error("Failed to download receipt");
      }
    },
    async viewReceiptInTab(data) {
      try {
        if (!data.businessWalletTransactionId) {
          this.$toast.error("Transaction ID not found");
          return;
        }

        const response = await this.$http.get(
          `transaction/transaction/${data.businessWalletTransactionId}`,
          {
            responseType: "blob",
          },
        );

        // Create blob URL and open in new tab
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");

        // Clean up the URL after a delay to allow the tab to load
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);

        this.$toast.success("Receipt opened in new tab");
      } catch (error) {
        console.error("Error opening PDF:", error);
        this.$toast.error("Failed to open receipt");
      }
    },
    ibd_status_update(data) {
      console.log(data);
      this.$bvModal.show("IBDStatusUpdate");
    },
    trans_payout_status_update(data) {
      // console.log(data);
      this.payoutStatusUpdate.transaction_id = data.id;
      this.payoutStatusUpdate.provider = "";
      this.payoutStatusUpdate.comment = "";
      this.$bvModal.show("payoutStatusUpdate");
    },
    manualConfirmSuccess(data) {
      this.manualConfirm.transaction_id = data.id;
      this.manualConfirm.title = "Transaction Success (Manual Confirm)";
      this.manualConfirm.reference_number = data.custRefno;
      this.manualConfirm.status = "Recipient Paid";
      this.manualConfirm.comment = "";
      this.$bvModal.show("manualConfirmModal");
    },
    manualConfirmFailed(data) {
      this.manualConfirm.transaction_id = data.id;
      this.manualConfirm.title = "Transaction Failed (Manual Confirm)";
      this.manualConfirm.reference_number = data.custRefno;
      this.manualConfirm.status = "Failed";
      this.manualConfirm.comment = "";
      this.$bvModal.show("manualConfirmModal");
    },
    manualConfirmSubmit() {
      let params = {
        transaction_id: this.manualConfirm.transaction_id,
        transaction_status: this.manualConfirm.status,
        comment: this.manualConfirm.comment,
      };
      const action = this.manualConfirm.status === "Recipient Paid"
        ? MANUAL_SUCCESS_TRANSACTION
        : MANUAL_FAIL_TRANSACTION;
      this.$store.dispatch(action, params).then((response) => {
        if (response.status == 200) {
          myFunction.showInfo(response.data.message, "success");
          this.$bvModal.hide("manualConfirmModal");
          this.getTransactionList();
        } else {
          if (response.data.message) {
            myFunction.showInfo(response.data.message, "error");
          } else {
            myFunction.showInfo(response.data.detail, "error");
          }
        }
      });
    },
    statusUpdateSubmit(type) {
      console.log("type", type);
      if (type == "transaction") {
        // console.log('transactionStatusUpdate',this.transactionStatusUpdate)
        let params = {
          transaction_id: this.transactionStatusUpdate.transaction_id,
          transaction_status: this.transactionStatusUpdate.status.status,
          comment: this.transactionStatusUpdate.comment,
        };
        this.$store
          .dispatch(UPDATE_TRANSACTION_STATUS, params)
          .then((response) => {
            if (response.status == 200) {
              myFunction.showInfo(response.data.message, "success");
              this.getTransactionList();
              this.$bvModal.hide("transactionStatusUpdate");
            } else {
              myFunction.showInfo(response.data.detail || response.data.message, "error");
            }
          });
      }
      if (type == "IBD") {
        console.log("IBDStatusUpdate", this.IBDStatusUpdate);
      }
      if (type == "payout_status") {
        // console.log('payout_status',this.transactionPayout)
        let params = {
          transaction_id: this.payoutStatusUpdate.transaction_id,
          provider_id: this.payoutStatusUpdate.provider.providerid,
          comment: this.payoutStatusUpdate.comment,
        };
        this.$store.dispatch(UPDATE_PAYOUT_STATUS, params).then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.getTransactionList();
            this.$bvModal.hide("payoutStatusUpdate");
          } else {
            myFunction.showInfo(response.data.detail, "error");
          }
        });
      }
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      myFunction.showInfo(`${type} Copied`, "success");
    },
    // for openFilters
    openFilters() {
      if (this.advanceFilters.length == 0) {
        this.advanceFilters = [
          {
            field: { id: "firstname", name: "Sender First Name", $isDisabled: true },
            search: "",
            country: [],
            transactionStatus: [],
            history: {
              sender: "",
              receiver: "",
            },
            date: {
              from: "",
              to: "",
            },
            amount: {
              type: "",
              value: "",
            },
            payout: {
              type: "",
              source: "",
            },
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // to append another Filter
    appendFilter() {
      this.advanceFilters.map((item) => {
        if (
          item.field.id != "amount" ||
          this.advanceFilters.filter((data) => data.field.id == "amount")
            .length > 2
        ) {
          this.filterField.filter(
            (data) => data.id == item.field.id,
          )[0].$isDisabled = true;
        }
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
          country: [],
          transactionStatus: [],
          history: {
            sender: "",
            receiver: "",
          },
          amount: {
            type: "",
            value: "",
          },
          date: {
            from: "",
            to: "",
          },
          payout: {
            type: "",
            source: "",
          },
        });
        if (
          this.filterField.filter((data) => data.$isDisabled == false)[0].id !=
          "amount"
        ) {
          this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0].$isDisabled = true;
        }
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        if (
          item.field.id != "amount" ||
          this.advanceFilters.filter((data) => data.field.id == "amount")
            .length > 2
        ) {
          this.filterField.filter(
            (data) => data.id == item.field.id,
          )[0].$isDisabled = true;
        }
        if (item.field.id != "amount") {
          item.amount.type = "";
          item.amount.value = "";
        }
      });
      this.amountFieldUpdate();
    },
    // to remove filters
    removeFilter(index) {
      if (this.advanceFilters[index].field.id == "amount") {
        this.amountOptions.filter(
          (data) => data.id == this.advanceFilters[index].amount.type.id,
        )[0].$isDisabled = false;
      }
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("transaction-list-filter", this.displayFilters);
    },
    // remove country filters
    removeCountry(country, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let countries = [];
      let countriesobj = [];
      temp.map((item) => {
        if (item != country) {
          countries.push(item);
          countriesobj.push(
            this.countryList.filter((data) => data.countryid === item)[0],
          );
        }
      });
      if (countries.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = countries;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].country = countriesobj;
        }
      });
      this.$cookies.set("transaction-list-filter", this.displayFilters);
      this.getTransactionList();
    },
    // remove transaction sattus filters
    removeStatus(status, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let statuses = [];
      let statusesobj = [];
      temp.map((item) => {
        if (item != status) {
          statuses.push(item);
          statusesobj.push(
            this.transactionStatus.filter((data) => data === item)[0],
          );
        }
      });
      if (statuses.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = statuses;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].transactionStatus = statusesobj;
        }
      });
      this.$cookies.set("transaction-list-filter", this.displayFilters);
      this.getTransactionList();
    },
    // remove date filters
    removeDate(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].date[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.from == "" && temp.to == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == "date")[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("transaction-list-filter", this.displayFilters);
    },
    // remove date filters
    removePayoutSource(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].payout[indexValue] = "";
      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.type == "" && temp.source == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter(
          (data) => data.id == "payout_source",
        )[0].$isDisabled = false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("transaction-list-filter", this.displayFilters);
    },
    // remove transaction_history filters
    removetransaction_history(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].history[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.sender == "" && temp.receiver == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter(
          (data) => data.id == "transaction_history",
        )[0].$isDisabled = false;
        this.displayFilters.splice(filterindex, 1);
      }
      if (this.$route.query.filter) {
        if (this.$route.query.sender && this.$route.query.receiver) {
          if (indexValue == "receiver") {
            this.$router.replace({
              query: { filter: "true", sender: this.$route.query.sender },
            });
          }
          if (indexValue == "sender") {
            this.$router.replace({
              query: { filter: "true", receiver: this.$route.query.receiver },
            });
          }
        } else {
          this.$router.replace({ query: {} });
          this.displayFilters = [];
        }
      } else {
        this.$cookies.set("transaction-list-filter", this.displayFilters);
      }
    },

    // amount filter fields update
    amountFieldUpdate() {
      this.amountOptions.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        if (item.amount.type) {
          this.amountOptions.filter(
            (data) => data.id == item.amount.type.id,
          )[0].$isDisabled = true;
        }
      });
    },

    // apply filters
    applyTestfilter() {
      if (this.$route.query.filter) {
        this.$router.replace({ query: {} });
      }
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
        };
        if (
          item.field.id == "firstname" ||
          item.field.id == "middlename" ||
          item.field.id == "lastname" ||
          item.field.id == "receiverfirstname" ||
          item.field.id == "receivermiddlename" ||
          item.field.id == "receiverlastname" ||
          //item.field.id == "email" ||
          //item.field.id == "senderphone" ||
          //item.field.id == "receiverphone" ||
          item.field.id == "transactiontype" ||
          item.field.id == "payment_res_id" ||
          item.field.id == "payout_res_id" ||
          item.field.id == "transaction_ref" ||
          item.field.id == "ip_address" ||
          item.field.id == "bank_name"
        ) {
          data.filter_value = item.search;
        }
        // Fix for mobile_network: store array of selected provider IDs for API, and objects for display
        if (item.field.id == "mobile_network") {
          data.filter_value = Array.isArray(item.mobile_network)
            ? item.mobile_network.map((opt) => opt.id || opt.value || opt)
            : [];
          data._mobile_network_objs = Array.isArray(item.mobile_network)
            ? item.mobile_network
            : [];
        }
        if (item.field.id == "country" || item.field.id == "sourcecountry") {
          let countries = [];
          item.country.map((country) => {
            countries.push(country.countryid);
          });
          data.filter_value = countries;
        }
        if (item.field.id == "transaction_status") {
          let statuses = [];
          item.transactionStatus.map((status) => {
            statuses.push(status);
          });
          data.filter_value = statuses;
        }
        if (item.field.id == "remitterstatus") {
          data.filter_value = item.search.value;
        }
        if (item.field.id == "cko_capture") {
          data.filter_value = item.search.name;
        }
        if (item.field.id == "date") {
          data.filter_value = {
            from: item.date.from
              ? moment(item.date.from).format("DD-MM-YYYY")
              : "",
            to: item.date.to ? moment(item.date.to).format("DD-MM-YYYY") : "",
          };
        }
        if (item.field.id == "amount") {
          if (item.amount.type && item.amount.value) {
            data.filter_value = item.amount.type.id + ": " + item.amount.value;
          }
        }
        if (item.field.id == "transaction_history") {
          data.filter_value = {
            sender: item.history.sender ? item.history.sender : "",
            receiver: item.history.receiver ? item.history.receiver : "",
          };
        }

        if (item.field.id == "payout_source") {
          data.filter_value = {
            type: item.payout.type.value ? item.payout.type.value : "",
            source: item.payout.source.value ? item.payout.source.value : "",
          };
        }

        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("transaction-list-filter", params);
      this.displayFilters = this.$cookies.get("transaction-list-filter");
      console.log("params", params);
    },
    // clear all filters
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "firstname", name: "Sender First Name", $isDisabled: true },
          search: "",
          country: [],
          transactionStatus: [],
          history: {
            sender: "",
            receiver: "",
          },
          date: {
            from: "",
            to: "",
          },
          amount: {
            type: "",
            value: "",
          },
          payout: {
            type: "",
            source: "",
          },
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      if (!this.$route.query.filter) {
        this.$cookies.set("transaction-list-filter", this.displayFilters);
      }
      this.getTransactionList();
    },
    customerDetailModel(item) {
      let params = {
        customer_id: item,
      };
      this.customerDetail = params;
      if (this.customerDetail.customer_id) {
        // Use $nextTick to ensure the prop is updated before modal opens
        this.$nextTick(() => {
          this.$bvModal.show("customer-details");
        });
      } else {
        myFunction.showInfo("Customer Details Not found", "error");
        this.customerDetail = null;
      }
    },
    getSelectedDateRange(e) {
      let startDate = moment(e[0]).format("D-MM-YYYY");
      let endDate = moment(e[1]).format("D-MM-YYYY");

      let tempArr = [];
      this.transactions.map((data) => {
        let formatResponseData = moment(data.datetime.date).format("D-MM-YYYY");

        var d1 = startDate.split("-");
        var d2 = endDate.split("-");
        var c = formatResponseData.split("-");

        var from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]); // -1 because months are from 0 to 11
        var to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
        var check = new Date(c[2], parseInt(c[1]) - 1, c[0]);

        if (check >= from && check <= to) {
          tempArr.push(data);
        }
      });
      this.transactions = tempArr;
      this.totalRows = this.transactions.length;
    },
    convertDate(data) {
      return moment(data).utc().format("DD-MM-YYYY HH:mm:ss");
    },
    convertToString(data) {
      return JSON.stringify(data);
    },
    async showTransactionDetail(data) {
      // console.log(data);
      this.$refs.loader.show();
      try {
        let paramData = {
          customer_ref: data.cust_ref, //'PA-64b501e0090921689584096-1'
        };
        const response = await this.$http.get(
          this.$apiV2transaction + "payment/transactions-details/",
          {
            params: paramData,
          },
        );
        if (response.data.code == "0130-000") {
          if (response.data.data.length > 0) {
            const transactionDetail = response.data;

            this.transactionDetail.accName = data.accno.acc;
            this.transactionDetail.accNumber = data.accno.no;
            this.transactionDetail.sendername =
              transactionDetail.senderFirstName +
              " " +
              transactionDetail.senderLastName;
            this.transactionDetail.beneficiaryname =
              transactionDetail.beneficiaryFirstName +
              " " +
              transactionDetail.beneficiaryLastName;
            this.transactionDetail.destamount =
              transactionDetail.receivingCurrency +
              " " +
              parseFloat(transactionDetail.destinationAmount).toFixed(2);
            this.transactionDetail.refno = data.cust_ref;
            this.transactionDetail.srcamount = data.srcamount;
            this.transactionDetail.transStatus = data.status.name;

            this.transactionDetail.details = response.data.data;
            //this.errorMsg = '';
            this.detailsstatus = false;
            this.$bvModal.show("show-details");
            this.$refs.loader.hide();
          } else {
            // console.log('No record found');
            this.detailsstatus = true;
            this.errorMsg = "No Details Found";
            this.$bvModal.show("show-details");
            this.$refs.loader.hide();
          }
        }
      } catch (error) {
        console.log(error);
        if (error.response.data.code == "E0130-001") {
          this.detailsstatus = true;
          this.errorMsg =
            "There are some validation error occured. Please refer merchant backend website";
          this.$bvModal.show("show-details");
          this.$refs.loader.hide();
        }
        this.$refs.loader.hide();
      }
    },

    //copy
    copyValue(keyvalue) {
      var copyVal = "";
      if (typeof keyvalue == "object") {
        copyVal = JSON.stringify(keyvalue);
      } else {
        copyVal = keyvalue;
      }
      navigator.clipboard.writeText(copyVal);
      shared.toastrSuccess("Successfully copied");
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },

    // showEdit(data){
    //     console.log(data);
    //     this.$router.push({ path: '/customer/edit' })
    // }
    async getTransactionList() {
      // Ensure countryList is loaded before proceeding
      if (!this.countryList || this.countryList.length === 0) {
        return;
      }
      let page = "";
      let size = "";
      let sortby = "";
      let sort = "";
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        size = this.perPage;
      } else {
        size = 10;
      }
      if (this.sortBy == "" || this.sortBy == "datetime") {
        sortby = "createdAt";
      } else {
        sortby = this.sortBy;
      }
      if (this.sortDesc == true) {
        sort = "desc"; //"DESC";
      } else {
        sort = "asc"; //"ASC";
      }

      this.currentPageJump = page;
      const tempitems = [];
      let tempparam = `?sort=${sort}&sortby=${sortby}&limit=${size}&page=${page}`; //
      if (this.searchText) {
        tempparam = tempparam + `&search=${this.searchText.trimStart()}`;
      }

      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          if (item.filter_field == "date") {
            tempparam = tempparam + `&date_from=${item.filter_value.from}`;
            tempparam = tempparam + `&date_to=${item.filter_value.to}`;
          }
          // else if (item.filter_field == "payout_source") {
          //   tempparam = tempparam + `&payout_type=${item.filter_value.type}`;
          //   tempparam =
          //     tempparam + `&payout_source=${item.filter_value.source}`;
          // }
          else if (item.filter_field == "transaction_history") {
            tempparam = tempparam + `&sender=${item.filter_value.sender}`;
            // tempparam = tempparam + `&receiver=${item.filter_value.receiver}`;
          } else if (item.filter_field == "amount") {
            let value = item.filter_value.split(":");
            tempparam = tempparam + `&amount=${value[1].replace(" ", "")}`;
            tempparam = tempparam + `&amount_type=${value[0]}`;
            // tempparam =
            //   tempparam +
            //   `&amount_${value[0]
            //     .replace(" ", "_")
            //     .toLowerCase()}=${value[1].replace(" ", "")}`;
          } else if (item.filter_field == "transaction_status") {
            item.filter_value.map((status) => {
              tempparam = tempparam + `&${item.filter_field}=${status}`;
            });
          } else {
            tempparam =
              tempparam + `&${item.filter_field}=${item.filter_value}`;
          }
        });
      }
      await this.$store
        .dispatch(GET_TRANSACTION_LIST, tempparam)
        .then((response) => {
          // JSON responses are automatically parsed.
          if (response.status == 200) {
            response.data.details.map((item) => {
              let accType = "";
              let accname = "";
              let accNumber = "";

              // Check for PW wallet transactions (reference starts with "PW" and source amount != dest amount)
              const isPWWallet =
                item.reference_number &&
                item.reference_number.startsWith("PW") &&
                item.sourceAmount &&
                item.destAmount;
              // &&  parseFloat(item.sourceAmount) !== parseFloat(item.destAmount);
              if (isPWWallet) {
                accType = "wallet";
                // Create intuitive wallet name showing currency swap
                const sourceCountryData = this.countryList.filter(
                  (data) => data.countryname === item.senderCountry,
                )[0];
                const destCountryData = this.countryList.filter(
                  (data) => data.currencycode === item.destCurrency,
                )[0];

                const sourceCurrency = sourceCountryData?.currency || "USD";
                const destCurrency =
                  destCountryData?.currency || item.destCurrency || "GHS";
                const walletSwapName = `${sourceCurrency} → ${destCurrency} Wallet`;
                accname = item.walletName ? item.walletName : walletSwapName;
                accNumber = item.accountNumber ? item.accountNumber : "-";
              } else if (item.payoutType == "Mobile Money") {
                accType = "mobile";
                accname = item.mobileNetwork ? item.mobileNetwork : "-";
                accNumber = item.mobileNumber ? item.mobileNumber : "-";
              } else if (item.payoutType == "Payangel Wallet") {
                accType = "wallet";
                accname = item.walletName ? item.walletName : "N/A";
                accNumber = item.accountNumber ? item.accountNumber : "-";
              } else {
                accType = "bank";
                accname = item.accountName ? item.accountName : "N/A";
                accNumber = item.accountNumber ? item.accountNumber : "-";
              }

              const transactionStatus = item.transactionStatus
                ? item.transactionStatus
                : "N/A";

              let platform = "";
              if (item.platform) {
                if (item.platform.toLowerCase() == "ios") {
                  platform = "fa fa-apple font-14 mr-1";
                } else if (item.platform.toLowerCase() == "android") {
                  platform = "fa fa-android text-success font-14 mr-1";
                } else if (item.platform.toLowerCase() == "admin") {
                  platform = "fa fa-user font-14 mr-1";
                } else if (item.platform.toLowerCase() == "web") {
                  platform = "fa fa-globe text-info font-14 mr-1";
                }
              }

              let paymentProvider = "";
              if (item.paymentProvider) {
                if (item.paymentProvider.toLowerCase() == "volume") {
                  paymentProvider = {
                    value: item.paymentProvider,
                    class: "text-purple",
                  };
                }
                if (item.paymentProvider.toLowerCase() == "checkout") {
                  paymentProvider = {
                    value: item.paymentProvider,
                    class: "text-blue",
                  };
                }
              }

              const senderfname = item.senderFirstName
                ? item.senderFirstName
                : "-";
              const senderlname = item.senderLastName
                ? item.senderLastName
                : "-";
              const beneficiaryfname = item.receiverFirstName
                ? item.receiverFirstName
                : "-";
              const beneficiarylname = item.receiverLastName
                ? item.receiverLastName
                : "-";

              // Determine payoutProvider logic
              let payoutProviderObj = " ";

              // For PW transactions with status ID 7, automatically set to Wallet
              if (item.reference_number &&
                  item.reference_number.startsWith('PW') &&
                  item.transactionStatusId === 7 &&
                  Array.isArray(this.payoutoption)) {
                payoutProviderObj =
                  this.payoutoption.find(
                    (option) => option.name && option.name.toLowerCase().includes('wallet')
                  ) || " ";
              } else if (
                (transactionStatus === "Recipient Paid" ||
                 transactionStatus === "Sent for Payment" ||
                 transactionStatus === "Awaiting Callback" ||
                 transactionStatus === "Failed") &&
                item.latestPayoutProviderId &&
                Array.isArray(this.payoutoption)
              ) {
                payoutProviderObj =
                  this.payoutoption.find(
                    (provider) =>
                      provider.providerid === item.latestPayoutProviderId ||
                      provider.id === item.latestPayoutProviderId, // fallback for different id keys
                  ) || " ";
              } else if (
                item.payoutProvider &&
                Array.isArray(this.payoutoption)
              ) {
                payoutProviderObj =
                  this.payoutoption.find(
                    (data) => data.name === item.payoutProvider,
                  ) || " ";
              }

              let transactionLists = {
                id: item.id,
                srccountry: {
                  flagClass:
                    "flag-icon flag-icon-" +
                    this.countryList.filter(
                      (data) => data.countryname === item.senderCountry,
                    )[0]?.isocode +
                    " fi-lg fi-round",
                },
                datetime: item.transaction_date,
                sender: { name: senderfname + " " + senderlname },
                benificiary: {
                  name: beneficiaryfname + " " + beneficiarylname,
                },
                accno: { type: accType, acc: accname, no: accNumber },
                destamount: item.destAmount
                  ? parseFloat(item.destAmount).toFixed(2)
                  : "N/A",
                custRefno: item.reference_number ? item.reference_number : "-",
                payout_res_id: item.payoutResID ? item.payoutResID : "-",
                payment_res_id: item.paymentResID ? item.paymentResID : "-",
                isCaptured: item.isCaptured,
                status: this.statusBadges(transactionStatus),
                transactionStatusId: item.transactionStatusId,
                payoutProvider: payoutProviderObj,
                paymentProvider: paymentProvider,
                customer_id: item.customerid,
                receiver_id: item.beneficaryId,
                transaction_id: item.transaction_id ? item.transaction_id : "-",
                uuid: item.id ? item.id : "-",
                sourceamount: item.sourceAmount
                  ? parseFloat(item.sourceAmount).toFixed(2)
                  : "N/A",
                platform: platform,
                country: this.countryList.filter(
                  (data) => data.countryname === item.senderCountry,
                )[0],
                destcountry: this.countryList.filter(
                  (data) => data.currencycode === item.destCurrency,
                )[0],
                sourceCurrencyCode:
                  item.sourceCurrency ||
                  this.countryList.filter(
                    (data) => data.countryname === item.senderCountry,
                  )[0]?.currencycode,
                destCurrencyCode: item.destCurrency,
                customerGroup: item.customerGroup ? item.customerGroup : "",
                noOfReceiver: item.noOfReceiver ? item.noOfReceiver : "-",
                senderCard: item.senderCard ? item.senderCard : "-",
                senderDTV: item.senderDTV ? item.senderDTV : "-",
                senderLTV: item.senderLTV ? item.senderLTV : "-",
                senderMTV: item.senderMTV ? item.senderMTV : "-",
                merchantReceiver: item.merchantReceiver
                  ? item.merchantReceiver
                  : isPWWallet
                    ? "PayWallet Business"
                    : null,
                businessWalletTransactionId: item.businessWalletTransactionId
                  ? item.businessWalletTransactionId
                  : isPWWallet
                    ? item.reference_number
                    : null,
                paymentMethodId: item.paymentMethodId,
                latestPayoutProviderId: item.latestPayoutProviderId || null,
                selected: false,
              };
              tempitems.push(transactionLists);
            });
            this.totalRows = response.data.query.total;
          } else {
            if (response.data.message) {
              myFunction.showInfo(response.data.message, "error");
            } else {
              myFunction.showInfo(response.data.detail, "error");
            }
          }
          this.transactions = tempitems;
          this.transactionsCopy = JSON.parse(JSON.stringify(tempitems));
        });
    },

    refreshTransactionTable() {
      this.$refs.transactionTable.refresh();
    },

    clearSearch() {
      this.searchText = "";
      this.$refs.transactionTable.refresh();
    },

    // async getTradename() {
    //   // console.log($pythonurl);
    //   try {
    //     this.tradename_options = [];
    //     let paramData = {
    //       pagesize: 200,
    //       pagenumber: 1,
    //       mode: "live",
    //     };
    //     // basepythonurl
    //     const response = await this.$http.get(
    //       this.$apiV2transaction + "payment/trade-name-list/",
    //       {
    //         params: paramData,
    //         headers: {
    //           Authorization:
    //             "Basic " + btoa(`${this.$username}:${this.$password}`),
    //         },
    //       }
    //     );
    //     if (response.data.code == "0130-000") {
    //       response.data.data.map((item) => {
    //         let tradeLists = {
    //           id: item.tradenameid,
    //           name: item.channel_name,
    //         };
    //         this.tradename_options.push(tradeLists);
    //       });
    //       // this.tradename = {id:this.tradename_options[0].id, name: this.tradename_options[0].name};
    //       // this.tradenameid = this.tradename_options[0].id;
    //       // this.refreshTransactionTable();
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     this.$refs.loader.hide();
    //   }
    // },

    setprovider(data) {
      // console.log(data);
      this.tradenameid = data.id;
      this.refreshTransactionTable();
    },
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
      if (/^\W$/.test(event.key)) {
        event.preventDefault();
      }
    },
    cookieFilters() {
      if (this.$route.query.filter) {
        this.advanceFilters = [
          {
            field: {
              id: "transaction_history",
              name: this.filterField.filter(
                (data) => data.id == "transaction_history",
              )[0].name,
              $isDisabled: true,
            },
            search: "",
            country: [],
            transactionStatus: [],
            history: {
              sender: this.$route.query.sender
                ? this.$route.query.sender
                : null,
              receiver: this.$route.query.receiver
                ? this.$route.query.receiver
                : null,
            },
            date: {
              from: "",
              to: "",
            },
            amount: {
              type: "",
              value: "",
            },
            payout: {
              type: "",
              source: "",
            },
          },
        ];
        this.displayFilters = [
          {
            filter_field: "transaction_history",
            field_name: "Transaction History",
            filter_value: {
              sender: this.$route.query.sender
                ? this.$route.query.sender
                : null,
              receiver: this.$route.query.receiver
                ? this.$route.query.receiver
                : null,
            },
          },
        ];
      } else {
        this.displayFilters =
          this.$cookies.get("transaction-list-filter") != null
            ? this.$cookies.get("transaction-list-filter")
            : [];
        let filters = [];
        if (this.displayFilters.length == 0) {
          this.displayFilters = [
            {
              filter_field: "transaction_status",
              field_name: "Transaction Status",
              filter_value: [
                "Processing",
                "Awaiting Funds",
                "Failed",
                "In Review",
              ],
            },
          ];
        }
        if (this.displayFilters && this.displayFilters.length > 0) {
          this.displayFilters.map((item) => {
            this.filterField.filter(
              (data) => data.id == item.filter_field,
            )[0].$isDisabled = true;
            if (
              item.filter_field == "firstname" ||
              item.filter_field == "middlename" ||
              item.filter_field == "lastname" ||
              item.filter_field == "receiverfirstname" ||
              item.filter_field == "receivermiddlename" ||
              item.filter_field == "receiverlastname" ||
              //item.filter_field == "email" ||
              //item.filter_field == "senderphone" ||
              //item.filter_field == "receiverphone" ||
              item.filter_field == "transactiontype" ||
              item.filter_field == "payment_res_id" ||
              item.filter_field == "payout_res_id" ||
              item.filter_field == "id" ||
              item.filter_field == "ip_address" ||
              item.filter_field == "mobile_network" ||
              item.filter_field == "bank_name"
            ) {
              console.log(item.filter_value);
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: item.filter_value,
                country: [],
                transactionStatus: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "remitterstatus") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: this.remiterOption.filter(
                  (data) => data.name == item.filter_value,
                )[0],
                country: [],
                transactionStatus: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "transaction_status") {
              let statuses = [];
              item.filter_value.map((status) => {
                statuses.push(
                  this.transactionStatus.filter((data) => data === status)[0],
                );
              });
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                transactionStatus: statuses,
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }

            if (
              item.filter_field == "country" ||
              item.filter_field == "sourcecountry"
            ) {
              let countries = [];
              item.filter_value.map((country) => {
                countries.push(
                  this.countryList.filter(
                    (data) => data.countryid === country,
                  )[0],
                );
              });
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: countries,
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "date") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: item.filter_value.from,
                  to: item.filter_value.to,
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "transaction_history") {
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: item.filter_value.sender,
                  receiver: item.filter_value.receiver,
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "amount") {
              this.amountOptions.filter(
                (data) => data.name == item.filter_value.split(":")[0],
              )[0].$isDisabled = true;
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: this.amountOptions.filter(
                    (data) => data.name == item.filter_value.split(":")[0],
                  )[0],
                  value: item.filter_value.split(":")[1],
                },
                payout: {
                  type: "",
                  source: "",
                },
              });
            }
            if (item.filter_field == "payout_source") {
              if (item.filter_value.type == "IBOBank") {
                this.payoutSourceOption = this.banks;
              }
              if (item.filter_value.type == "mobilemoney") {
                this.payoutSourceOption = this.mobileNetworks;
              }
              filters.push({
                field: {
                  id: item.filter_field,
                  name: this.filterField.filter(
                    (data) => data.id == item.filter_field,
                  )[0].name,
                  $isDisabled: true,
                },
                search: "",
                country: [],
                history: {
                  sender: "",
                  receiver: "",
                },
                date: {
                  from: "",
                  to: "",
                },
                amount: {
                  type: "",
                  value: "",
                },
                payout: {
                  type: this.filterpayouttype.filter(
                    (data) => data.value == item.filter_value.type,
                  )[0],
                  source: this.payoutSourceOption.filter(
                    (data) => data.value == item.filter_value.source,
                  )[0],
                },
              });
            }
          });
          this.advanceFilters = filters;
        }
      }
    },
    // get transaction status list
    getTransactionStatus() {
      this.$store.dispatch(GET_TRANSACTION_STATUS).then((response) => {
        if (response.data.code == "1005-000") {
          // Filter out "Funds Received" from the status update options
          this.UpdateStatusoption = response.data.details.filter(
            status => status.status !== "Funds Received"
          );
          // Populate filter dropdown options (extract status names as strings)
          this.transactionStatus = response.data.details.map(item => item.status);
        }
      });
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (this.sortBy != "") {
        this.getTransactionList();
      }
    },

    // For advance filter mobile money provider list
    async getAllMomonetworks() {
      let params = ``;
      // let params = `?countryid=${country_id}`;
      this.momoProviderList = [];
      await this.$store
        .dispatch(TRANSACTION_MOMO_NETWORKS, params)
        .then((response) => {
          if (response.status == 200) {
            this.momoProviderList = response.data.details;
          }
        });
    },

    // Called when user selects destination countries in the filter
    async getCountryWiseMomoProvider(selectedCountries) {
      // selectedCountries is an array of country objects
      const countryIds = Array.isArray(selectedCountries)
        ? selectedCountries.map((c) => c.countryid)
        : [];
      const countryIdString = countryIds.join(",");
      // console.log('Selected Dest. Country IDs (comma separated):', countryIdString);
      // await this.getAllMobilenetworks(countryIdString);
      let params = `?countryid=${countryIdString}`;
      this.momoProviderList = [];
      await this.$store
        .dispatch(TRANSACTION_MOMO_NETWORKS, params)
        .then((response) => {
          if (response.status == 200) {
            this.momoProviderList = response.data.details;
          }
        });
    },
    // (removed removeMobileNetwork)

    // remove Network filters
    removeNetwork(country, field, filterindex) {
      let temp = this.displayFilters.filter(
        (data) => data.filter_field == field,
      )[0].filter_value;
      let countries = [];
      let countriesobj = [];
      temp.map((item) => {
        if (item != country) {
          countries.push(item);
          countriesobj.push(
            this.momoProviderList.filter((data) => data.countryid === item)[0],
          );
        }
      });
      if (countries.length > 0) {
        this.displayFilters.filter(
          (data) => data.filter_field == field,
        )[0].filter_value = countries;
      } else {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == field)[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.advanceFilters.map((item, index) => {
        if (item.field.id == field) {
          this.advanceFilters[index].country = countriesobj;
        }
      });
      this.$cookies.set("transaction-list-filter", this.displayFilters);
      this.getTransactionList();
    },

    
    // get Country Wise Bank List
    async getCountryWiseBank(country_id) {
      let params = `?countryid=${country_id}&size=5000&page=1`;
      this.bank_options = [];
      const uniqueNames = new Set(); // track unique bank names
      await this.$store
        .dispatch(TRANSACTION_BANK_LIST, params)
        .then((response) => {
          if (response.status == 200) {
            const details = response.data.details;
            details.forEach((item) => {
              if (!uniqueNames.has(item.bank_name)) { // check for uniqueness
                uniqueNames.add(item.bank_name);

                this.bank_options.push({
                  id: item.id,
                  name: item.bank_name,
                  bank_code: item.bank_code, 
                });
              }
            });
          }
        });
    },
    // Edit bank account
    async bankAccountEdit(data){
      await this.getCountryWiseBank(data.destcountry?.countryid);
      this.updateBank.id = data.id;
      this.updateBank.bank = this.bank_options.filter(
        (item) => item.name === data.accno.acc
      )[0];
      this.updateBank.account = data.accno.no;
      this.updateBank.comment = "";
      this.$bvModal.show("editBankAccount");
    },
    // Update bank account
    updateBankAccount() {
      let params = {
        transactionid: this.updateBank.id,
        bank: this.updateBank.bank.name,
        bank_code: this.updateBank.bank.bank_code,
        bankid: this.updateBank.bank.id,
        account: this.updateBank.account,
        comment: this.updateBank.comment,
      };
      this.$store
        .dispatch(UPDATE_TRANSACTION_BANK_ACCOUNT, params)
        .then((response) => {
          if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.$bvModal.hide("editBankAccount");
            this.getTransactionList();
          } else {
            if (response.data.detail) {
              myFunction.showInfo(response.data.detail, "error");
            } else {
              myFunction.showInfo(response.data.message, "error");
            }
          }
        });
    },
  },
  // Only one correct definition, just before data()
  data() {
    return {
      mobileInputError: true,
      isDisplayPhoneError: false,
      primaryMobileNumber: {
        mode: "auto",
        defaultCountry: "",
        autoFormat: false,
        dropdownOptions: {
          showFlags: true,
          disabled: true,
          showDialCodeInSelection: true,
        },
      },
      updateMobile: {
        id: "",
        network: "",
        phoneNumber: "",
        comment: "",
        countryCode: "",
      },
      network_options: [],
      updateBank: {
        id: "",
        bank: "",
        account: "",
        comment: "",
      },
      bank_options: [],
      transactionProcess: {
        transaction_id: "",
        status: "",
        reason: "",
        refundmethod: "",
        comment: "",
        providerid: "",
      },
      notification: {
        type: "",
        action: "",
        custom: "RE : [trans_ref_#]",
      },
      showAlertTop: false,
      comment_transaction: {
        type: "",
        comment: "",
      },
      transactionStatusUpdate: {
        transaction_id: "",
        status: "",
        comment: "",
      },
      payoutStatusUpdate: {
        transaction_id: "",
        provider: "",
        comment: "",
      },
      manualConfirm: {
        transaction_id: "",
        title: "",
        reference_number: "",
        status: "",
        comment: "",
      },
      displayFilters: [],
      IBDStatusUpdate: "Error",
      notificationTypeOptions: [
        "Push notification",
        "Dismiss popup",
        "Model popup",
        "SMS",
      ],
      notificationActionOptions: ["ID Notification", "Other"],
      filterField: [
        { id: "firstname", name: "Sender First Name", $isDisabled: false },
        { id: "middlename", name: "Sender Middle Name", $isDisabled: false },
        { id: "lastname", name: "Sender Last Name", $isDisabled: false },
        { id: "receiverfirstname", name: "Receiver First Name", $isDisabled: false },
        { id: "receivermiddlename", name: "Receiver Middle Name", $isDisabled: false },
        { id: "receiverlastname", name: "Receiver Last Name", $isDisabled: false },
        //{ id: "email", name: "Email", $isDisabled: false },
        //{ id: "senderphone", name: "Sender Phone", $isDisabled: false },
        //{ id: "receiverphone", name: "Receiver Phone", $isDisabled: false },
        { id: "ip_address", name: "Registered IP", $isDisabled: false },
        { id: "country", name: "Dest. Country", $isDisabled: false },
        { id: "sourcecountry", name: "Source Country", $isDisabled: false },
        { id: "date", name: "Date", $isDisabled: false },
        { id: "remitterstatus", name: "Remitter Status", $isDisabled: false },
        {
          id: "transaction_status",
          name: "Transaction Status",
          $isDisabled: false,
        },
        { id: "transactiontype", name: "Transaction Type", $isDisabled: false },
        {
          id: "transaction_history",
          name: "Transaction History",
          $isDisabled: false,
        },
        {
          id: "transaction_ref",
          name: "Transaction Ref. ID",
          $isDisabled: false,
        },
        { id: "payment_res_id", name: "Payment Ref. ID", $isDisabled: false },
        { id: "payout_res_id", name: "Payout Ref. ID", $isDisabled: false },
        // { id: "payout_source", name: "Payout Source", $isDisabled: false },
        { id: "cko_capture", name: "CKO Capture Status", $isDisabled: false },
        { id: "amount", name: "Amount", $isDisabled: false },
        {
          id: "mobile_network",
          name: "Mobile Money Network",
          $isDisabled: false,
        },
        { id: "bank_name", name: "Bank Name", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "firstname", name: "Sender First Name", $isDisabled: false },
          search: "",
          country: [],
          transactionStatus: [],
          date: {
            from: "",
            to: "",
          },
          history: {
            sender: "",
            receiver: "",
          },
          amount: {
            type: "",
            value: "",
          },
          payout: {
            type: "",
            source: "",
          },
        },
      ],
      payoutSourceOption: [],
      momoProviderList: [],
      filterpayouttype: [
        { value: "mobilemoney", name: "Mobile Money" },
        { value: "IBOBank", name: "IBO Bank" },
      ],
      mobileNetworks: [
        { value: "airtel", name: "Airtel" },
        { value: "vodafone", name: "Vodafone" },
      ],
      banks: [
        { value: "royal bank", name: "Royal Bank" },
        { value: "world bank", name: "World Bank" },
        { value: "swiss bank", name: "Swiss Bank" },
      ],
      testFilter: false,
      dateRange: null,
      detailsstatus: false,
      errorMsg: "",
      customerDetail: null,
      remitterCredit: {
        customer: "",
        comment: "",
        amount: "",
        creditType: "",
        refundType: "",
      },

      transactionDetail: {
        accName: "",
        accNumber: "",
        sendername: "",
        beneficiaryname: "",
        srcamount: "",
        destamount: "",
        refno: "",
        transStatus: "",
        details: [],
      },

      transactions: [],
      transactionsCopy: [],

      fields: [
        {
          key: "selected",
          label: "Select",
          sortable: false,
          thStyle: { width: "2%", "padding-left": ".35rem !important" },
          thClass: "th_sortfix pl-0 text-left",
        },
        {
          key: "srccountry",
          label: "S.C.",
          sortable: false,
          thClass: "th_sortfix text-left",
        },
        {
          key: "datetime",
          label: "Date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "sender",
          label: "Sender",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "benificiary",
          label: "Receiver",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "accno",
          label: "Account No.",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "custRefno",
          label: "Trans. Ref",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "sourceamount",
          label: "Source Amount",
          sortable: false,
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "destamount",
          label: "Dest Amount",
          sortable: false,
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "status",
          label: "Trans. Status",
          sortable: false,
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "payout",
          label: "Payout",
          sortable: false,
          thClass: "th_sortfix text-center",
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      selectAll: false,
      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 100, 150, 200, { value: 1000, text: 1000 }],
      sortBy: "datetime",
      sortDesc: true,
      sortDirection: "asc",
      // newMemberUrl: window.location.origin+'/members-form/members-form.html',

      isVisibleFilter: false,

      searchText: "",

      tradename: {},
      tradename_options: [],
      tradenameid: "",
      remiterOption: [
        { value: "Basic", name: "Basic" },
        { value: "Bronze", name: "Bronze" },
        { value: "Silver", name: "Silver" },
        { value: "Silver Plus", name: "Silver Plus" },
      ],
      transactionStatus: [],
      // Constants for EUR Funds Received special case
      EUR_FUNDS_RECEIVED_PAYMENT_METHOD_ID: 'c911fab5-af81-4869-8da7-9a5465d456ec',
      EUR_FUNDS_RECEIVED_STATUS: 'Awaiting Funds',
      UpdateStatusoption: [],
      IBDStatusoption: [
        "Pending",
        "Success",
        "Error",
        "Failed",
        "Paid GT-OLB",
        "Paid NSANO",
        "Paid-CBG-ACH",
        "Paid-PGL",
        "ACH",
        "Paid HK PINOY",
      ],
      provideroption: [],
      bulkCapturestatus: "",
      bulkCaptureOption: [
        "GT-MDW",
        "NSANO",
        "ACH",
        "MIDDLE-WARE",
        "MDW-Rafiki",
        "MDW-PayAza",
        "MDW-CBG",
        "MDW-Terrapay",
        "MDW-Ghipss",
        "AZA-FIN",
        "MFS",
        "GTdirect-112",
        "PGL",
        "RIPPLE-NET",
        "Failed",
      ],
      payoutoption: [],
      typeoption: ["Customer", "Partner"],
      channelTypes: ["a", "b", "c"],
      amountOptions: [
        { id: "gte", name: "Greater Than", $isDisabled: false },
        { id: "lte", name: "Less Than", $isDisabled: false },
        { id: "eq", name: "Equals", $isDisabled: false },
      ],
      transactiontypeOptions: [
        "Mobile Money",
        "Bank Deposit",
        "Cash Collection",
      ],
      refund_method_Options: ["Wallet", "Account", "No Refund"],
      transactionReasons: [],
    };
  },
  async mounted() {
    this.totalRows = this.transactions.length;
    //this.getTradename();
    await this.getProvider();
    await this.getAllMomonetworks();
    await this.getTransactionStatus();
    await this.cookieFilters();
    // Ensure countryList is loaded before fetching transactions
    if (!this.countryList || this.countryList.length === 0) {
      await this.$store.dispatch(COUNTRYLIST);
    }
    this.getTransactionList();
  },
  watch: {
    displayFilters: {
      handler() {
        if (this.displayFilters.length > 0) {
          this.getTransactionList();
        }
      },
      immediate: false,
    },
    currentPage: {
      handler: function () {
        this.getTransactionList();
      },
    },
    perPage: {
      handler: function () {
        this.getTransactionList();
      },
    },
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
  },
};
</script>
<style>
text-grey {
  color: #8a8a8a !important;
}
.transaction-details-body {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
}
.transaction-raw-details-body {
  display: block;
  margin-left: 10px;
  width: 65%;
}
.transaction-raw-details-body .hide {
  display: none;
}
.transaction-lg-modal {
  max-width: 800px;
}
.scroll {
  overflow-y: scroll;
}
.max-width {
  width: 100%;
}
.transaction-alert {
  position: fixed;
  z-index: 9999;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
